import DownloadFromWebAPI from "utils/DownloadFromWebAPI";
import config from "config";
import moment from "moment";

let attrTitleStyle = {
  fontWeight: "bold",
  fontSize: "13px",
  textDecoration: "underline",
};

export default [
  {
    name: "Man-made Features",
    type: "mms",
    displayField: "SLOPE_NO",
    itemDetailType: "mms",
  },
  {
    name: "UAV",
    type: "uav",
    is3DOnly: true,
    displayField: "key",
  },
  {
    name: "Active Sites - Civil Engg. Projects",
    layer: "SlopeInfo",
    layerId: 49,
    itemDetailType: "attrTbl",
    aliasList: [
      { Name: "Contract No.", Value: "Cont_No" },
      { Name: "Project Office", Value: "Proj_Office" },
      { Name: "Contract Title", Value: "Cont_Title" },
      { Name: "Contract Sum (M)", Value: "Cont_Sum" },
      { Name: "Contractor", Value: "Contractor" },
      { Name: "Consultant", Value: "Consultant" },
      { Name: "Resident Engineer", Value: "RE" },
      { Name: "Resident Engineer Tel.", Value: "RE_Tel" },
      { Name: "Project Engineer", Value: "PE" },
      { Name: "Project Engineer Post", Value: "PE_Post" },
      { Name: "Project Engineer Tel.", Value: "PE_Tel" },
      { Name: "Work Commencement Date", Value: "Work_Comm_Date", type: "date" },
      { Name: "Work Completion Date", Value: "Work_Comp_Date", type: "date" },
      { Name: "District", Value: "District" },
      { Name: "Work Status", Value: "Work_Status" },
      { Name: "Work Brief", Value: "Work_Brief" },
    ],
  },
  {
    name: "Active Sites - LPM",
    layer: "SlopeInfo",
    layerId: 47,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      {
        Name: <span>LPM/LPMit Details</span>,
        type: "title",
      },
      {
        Name: "Feature/Catchment No.",
        Value: "SLOPE_NO",
        format: (v, r) => `${v} (${r.HLC_RC_FEA})`,
      },
      { Name: "Location", Value: "LOCATION" },
      { Name: "District Council", Value: "DIST" },
      { Name: "Plan Area", Value: "AREA" },
      {
        Name: "Responsible Party for Maintenance of Government Portion",
        Value: "SIS_MR",
      },
      { Name: <span />, type: "title" },
      {
        Name: <span>LPM/LPMit Study</span>,
        type: "title",
      },
      { Name: "Agreement No.", Value: "Agree_No" },
      { Name: "Study Type", Value: "S_STUDYTYP" },
      {
        Name: "Consultant",
        Value: "Consultant",
        format: (v, r) => `${v} (${r.RE})`,
      },
      {
        Name: "GEO Managing Section / Engineer",
        Value: "Agree_Div",
        format: (v, r) => `${v} / ${r.Agree_Sect} (${r.PE})`,
      },
      { Name: "Commencement Date", Value: "S_COMMDATE", type: "date" },
      { Name: "Completion Date", Value: "S_COMPDATE", type: "date" },
      { Name: "Study Status", Value: "S_STATUS" },
      { Name: <span />, type: "title" },
      {
        Name: <span>LPM/LPMit Works</span>,
        type: "title",
      },
      { Name: "Works Contract No.", Value: "Contract_N" },
      {
        Name: "Consultant",
        Value: "Consultant",
        format: (v, r) => `${v} (${r.RE})`,
      },
      {
        Name: "GEO Managing Section / Engineer",
        Value: "Agree_Div",
        format: (v, r) => `${v} / ${r.Agree_Sect} (${r.PE})`,
      },
      { Name: "Contractor", Value: "Contractor" },
      { Name: "Commencement Date", Value: "W_COMMDATE", type: "date" },
      { Name: "Completion Date", Value: "W_COMPDATE", type: "date" },
      { Name: "Works Status", Value: "WorkStatus" },
    ],
  },
  {
    name: "Active Sites - Polygon",
    layer: "SlopeInfo",
    layerId: 47,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "Active Sites - LPM",
    aliasList: [
      {
        Name: <span>LPM/LPMit Details</span>,
        type: "title",
      },
      {
        Name: "Feature/Catchment No.",
        Value: "SLOPE_NO",
        format: (v, r) => `${v} (${r.HLC_RC_FEA})`,
      },
      { Name: "Location", Value: "LOCATION" },
      { Name: "District Council", Value: "DIST" },
      { Name: "Plan Area", Value: "AREA" },
      {
        Name: "Responsible Party for Maintenance of Government Portion",
        Value: "SIS_MR",
      },
      { Name: <span />, type: "title" },
      {
        Name: <span>LPM/LPMit Study</span>,
        type: "title",
      },
      { Name: "Agreement No.", Value: "Agree_No" },
      { Name: "Study Type", Value: "S_STUDYTYP" },
      {
        Name: "Consultant",
        Value: "Consultant",
        format: (v, r) => `${v} (${r.RE})`,
      },
      {
        Name: "GEO Managing Section / Engineer",
        Value: "Agree_Div",
        format: (v, r) => `${v} / ${r.Agree_Sect} (${r.PE})`,
      },
      { Name: "Commencement Date", Value: "S_COMMDATE", type: "date" },
      { Name: "Completion Date", Value: "S_COMPDATE", type: "date" },
      { Name: "Study Status", Value: "S_STATUS" },
      { Name: <span />, type: "title" },
      {
        Name: <span>LPM/LPMit Works</span>,
        type: "title",
      },
      { Name: "Works Contract No.", Value: "Contract_N" },
      {
        Name: "Consultant",
        Value: "Consultant",
        format: (v, r) => `${v} (${r.RE})`,
      },
      {
        Name: "GEO Managing Section / Engineer",
        Value: "Agree_Div",
        format: (v, r) => `${v} / ${r.Agree_Sect} (${r.PE})`,
      },
      { Name: "Contractor", Value: "Contractor" },
      { Name: "Commencement Date", Value: "W_COMMDATE", type: "date" },
      { Name: "Completion Date", Value: "W_COMPDATE", type: "date" },
      { Name: "Works Status", Value: "WorkStatus" },
    ],
  },
  {
    name: "Advisory Letter Cases",
    layer: "SlopeInfo",
    layerId: 9,
    itemDetailType: "API",
    srvEndPt: "AdvisoryLetterCase",
    queryValue: "AL_REF",

    aliasList: [
      { Name: "Case Ref", Value: "ACASE_REF" },
      { Name: "GEO Case Ref", Value: "GEO_FILE" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Type", Value: "RECOM_TYPE" },
      { Name: "Date of Recommendation", Value: "DATE_RECOM" },
      { Name: "LPM Case (Y/N)", Value: "LPM_CASE" },
      { Name: "Case Cancelled (Y/N)", Value: "C_CANCEL" },
      { Name: "Remarks", Value: "C_REMARKS" },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
    ],
  },
  {
    name: "Advisory Letters",
    layer: "SlopeInfo",
    layerId: 10,
    itemDetailType: "API",
    srvEndPt: "AdvisoryLetter",
    queryValue: "REF",

    aliasList: [
      { Name: "Letter Ref", Value: "LID" },
      { Name: "Type", Value: "TYPE" },
      { Name: "Date of Issue", Value: "DATE_ISSUE" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Lot No.", Value: "LOT_NO" },
      { Name: "Area Code", Value: "AREA_CODE" },
      { Name: "GEO File", Value: "GEO_FILE" },
      { Name: "BD File", Value: "BD_FILE" },
      { Name: "LPM Case", Value: "LPM_CASE" },
      { Name: "Cancelled", Value: "CANCELLED" },
      { Name: "Remarks", Value: "REMARKS" },
      { Name: "Case Ref", Value: "CASE_REF" },
    ],
  },
  {
    name: "Advisory Projects",
    layer: "SlopeInfo",
    layerId: 14,
    itemDetailType: "API",
    srvEndPt: "AdvisoryProject",
    queryValue: "TAGMARK",

    aliasList: [],
    attrTransform: (mResult, attributes, user, showDialog) => {
      let pGraphic = { attributes };
      let mDataSet = [
        { Name: "File Reference", Value: mResult.TAGMARK, URL: "" },
        { Name: "Project Title", Value: mResult.PROJECT_TITLE, URL: "" },
        { Name: "Report Number 1", Value: mResult.REPORT_NUMBER1, URL: "" },
        { Name: "Report Number 2", Value: mResult.REPORT_NUMBER2, URL: "" },
        { Name: "Report Number 3", Value: mResult.REPORT_NUMBER3, URL: "" },
        { Name: "Report Number 4", Value: mResult.REPORT_NUMBER4, URL: "" },
        { Name: "Report Number 5", Value: mResult.REPORT_NUMBER5, URL: "" },
        { Name: "Report Number 6", Value: mResult.REPORT_NUMBER6, URL: "" },
        { Name: "Report Number 7", Value: mResult.REPORT_NUMBER7, URL: "" },
        { Name: "Report Number 8", Value: mResult.REPORT_NUMBER8, URL: "" },
        { Name: "Report Number 9", Value: mResult.REPORT_NUMBER9, URL: "" },
        { Name: "Report Number 10", Value: mResult.REPORT_NUMBER10, URL: "" },
        { Name: "Report Number 11", Value: mResult.REPORT_NUMBER11, URL: "" },
        { Name: "Report Number 12", Value: mResult.REPORT_NUMBER12, URL: "" },
        { Name: "Type of Works 1", Value: mResult.TYPE_OF_WORKS_1, URL: "" },
        { Name: "Type of Works 2", Value: mResult.TYPE_OF_WORKS_2, URL: "" },
        { Name: "Client Office", Value: mResult.CLIENT_OFFICE, URL: "" },
        {
          Name: "Date Boundary Digitised",
          Value: mResult.DATE_BOUNDARY_DIGITISED,
          URL: "",
        },
        {
          Name: "Date Boundary Reviewed",
          Value: mResult.DATE_BOUNDARY_REVIEWED,
          URL: "",
        },
        {
          Name: "Project Boundary Available",
          Value: mResult.PROJECT_BOUNDARY_AVAILABLE,
          URL: "",
        },
        { Name: "Easting", Value: pGraphic.attributes["EASTING"], URL: "" },
        { Name: "Northing", Value: pGraphic.attributes["NORTHING"], URL: "" },
      ];
      for (var i = 0; i < mResult.PDFs.length; i++) {
        var mPDF = mResult.PDFs[i];
        var mDataPDF = undefined;
        if ([1, 2, 3, 8].includes(user.userGroup)) {
          var mURL = mPDF.URL;
          mDataPDF = {
            Name: "Hotlink",
            Value: (
              <a href={DownloadFromWebAPI(mURL)} target="_blank">
                {mPDF.FILE_NAME}
              </a>
            ),
          };
        } else {
          mDataPDF = {
            Name: "Hotlink",
            Value: (
              <span
                onClick={() =>
                  showDialog({
                    isOpen: true,
                    type: "error",
                    title: "Access Denied",
                    content: "The user has no permission to open this report",
                    onDialogOk: () => {},
                  })
                }
              >
                {mPDF.FILE_NAME}
              </span>
            ),
          };
        }
        mDataSet.push(mDataPDF);
      }
      return mDataSet;
    },
  },
  {
    name: "Antiquities and Monuments",
    layer: "SlopeInfo",
    layerId: 65,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    aliasList: [
      { Name: "AMO Research File Reference", Value: "SHAI_AMONO" },
      {
        Name: "Class/Status",
        Value: "SHAI_CLASS",
        format: (v, r) => {
          var mSHAI_CLASS = v;
          if (mSHAI_CLASS == "A")
            mSHAI_CLASS = "Sites of Archaeological Interest";
          if (mSHAI_CLASS == "G")
            mSHAI_CLASS = "Government Historic Sites Identified by AMO";
          if (mSHAI_CLASS == "H") mSHAI_CLASS = "Graded Historic Buildings";
          if (mSHAI_CLASS == "M") mSHAI_CLASS = "Proposed Monument";
          if (mSHAI_CLASS == "P")
            mSHAI_CLASS =
              "Declared Monuments (Sites of Archaeological Interest)";
          if (mSHAI_CLASS == "Q")
            mSHAI_CLASS = "Declared Monuments (Historic Buildings)";
          return mSHAI_CLASS;
        },
      },
      { Name: "Grade", Value: "SHAI_GRADE" },
      { Name: "Name in English", Value: "SHAI_ENGNM" },
      { Name: "Name in Chinese", Value: "SHAI_CHNM" },
      { Name: "Address in English", Value: "SHAI_LOC" },
      { Name: "Address in Chinese", Value: "SHAI_CHLOC" },
      { Name: "District", Value: "DISTRICT" },
    ],
  },
  {
    name: "Boulder",
    layer: "SlopeInfo",
    layerId: 49,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Boulder No.", Value: "KEY" },
      { Name: "Map Sheet", Value: "SHEETNO" },
      {
        Name: "Boulder Type",
        Value: "ATTRIB_2",
        format: (v, r) => {
          let mBoulderType = v;
          if (mBoulderType == "1") {
            mBoulderType = "Corestone or Tor";
          } else if (mBoulderType == "2") {
            mBoulderType = "Colluvial boulder field";
          } else if (mBoulderType == "3") {
            mBoulderType = "Cliff or rock outcrop";
          } else if (mBoulderType == "4") {
            mBoulderType = "Scree or talus deposit";
          }
          return mBoulderType;
        },
      },
      {
        Name: "% of area covered by boulders",
        Value: "ATTRIB_1",
        format: (v, r) => {
          let mBoulderCoverage = v;
          if (mBoulderCoverage == "1") {
            mBoulderCoverage = "< 10%";
          } else if (mBoulderCoverage == "2") {
            mBoulderCoverage = "10-20%";
          } else if (mBoulderCoverage == "3") {
            mBoulderCoverage = "20-50%";
          } else if (mBoulderCoverage == "4") {
            mBoulderCoverage = "50-75%";
          } else if (mBoulderCoverage == "5") {
            mBoulderCoverage = "> 75%";
          } else if (mBoulderCoverage == "C") {
            mBoulderCoverage = "Obscured by cloud";
          } else if (mBoulderCoverage == "V") {
            mBoulderCoverage = "Covered by vegetation";
          } else if (mBoulderCoverage == "T") {
            mBoulderCoverage = "Terrain shadow";
          } else if (mBoulderCoverage == "S") {
            mBoulderCoverage = "Village  housing";
          } else if (mBoulderCoverage == "B") {
            mBoulderCoverage = "Beach deposit";
          } else if (mBoulderCoverage == "X") {
            mBoulderCoverage = "Indiviudal outcorp on vegetation";
          } else if (mBoulderCoverage == "Z") {
            mBoulderCoverage = "Not cover by low-altitude photo";
          } else {
            mBoulderCoverage = "No data";
          }
          return mBoulderCoverage;
        },
      },
      { Name: "% of boulder < 1 m", Value: "ATTRI3_S1" },
      { Name: "% of boulder 1-2 m", Value: "ATTRI3_S2" },
      { Name: "% of boulder 2-5 m", Value: "ATTRI3_S3" },
      { Name: "% of boulder > 5 m", Value: "ATTRI3_S4" },
    ],
  },
  {
    name: "CEDD - TGLA",
    layer: "SlopeInfo",
    layerId: 51,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Site ID", Value: "Site_ID" },
      { Name: "Project Office", Value: "Project_Office" },
      { Name: "TGLA No.", Value: "TGLA_Number" },
      { Name: "Location", Value: "Location" },
      { Name: "Contract No.", Value: "Contract_No" },
      { Name: "Contract Title", Value: "Contract_Title" },
      { Name: "Commencement Date", Value: "Commencement_Date", type: "date" },
      { Name: "Expiry Date", Value: "Expiry_Date", type: "date" },
      { Name: "Area (sq. m.)", Value: "Area" },
      { Name: "Land Usage", Value: "Land_Usage" },
      { Name: "Remarks", Value: "Remarks" },
    ],
  },
  {
    name: "Dangerous Road Sign",
    layer: "SlopeInfo",
    layerId: 72,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Reference", Value: "REFERENCE" },
      { Name: "Lamp Post", Value: "LAMPPOST" },
      { Name: "Road Name", Value: "ROAD_NAME" },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
      {
        Name: "Hotlink",
        Value: "HOTLINK",
        format: (mHotlink, r) => (
          <a
            href={DownloadFromWebAPI([
              "WarningSign",
              mHotlink
                .replace("\\\\10.9.28.35\\layers_ info\\BRIL\\", "")
                .replace("\\", "/"),
            ])}
            target="_blank"
          >
            Open
          </a>
        ),
      },
    ],
  },
  {
    name: "DH Cases",
    layer: "SlopeInfo",
    layerId: 7,
    itemDetailType: "API",
    srvEndPt: "DHCase",
    queryValue: "REF",

    aliasList: [
      { Name: "Case Ref", Value: "CASE_REF" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Area Code", Value: "AREA_CODE" },
      { Name: "Date of Recommendation", Value: "DATE_RECOM" },
      { Name: "Type", Value: "RECOM_TYPE" },
      { Name: "GEO File Ref", Value: "GEO_FILE" },
      { Name: "Case Cancelled (Y/N)", Value: "C_CANCEL" },
      { Name: "LPM Case (Y/N)", Value: "LPM_CASE" },
      { Name: "Remarks", Value: "C_REMARKS" },
      { Name: "Agreement No.", Value: "AGMT_NO" },
      { Name: "Last Update Date", Value: "LASTUPDATEDATE" },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
    ],
  },
  {
    name: "DH Files",
    layer: "SlopeInfo",
    layerId: 6,
    itemDetailType: "API",
    srvEndPt: "DHFiles",
    queryValue: "REF",

    aliasList: [
      { Name: "Ref", Value: "FILEREF" },
      { Name: "File Title", Value: "TITLE" },
      {
        Name: "Hotlink",
        Value: "URL",
        format: (v, r) => (
          <a href={v} target="_blank">
            Open PDF
          </a>
        ),
      },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
    ],
    attrTransform: function(mResults, attributes) {
      let pGraphic = { attributes };
      let mDataSet = [];
      for (let i = 0; i < mResults.length; i++) {
        var mResult = mResults[i];
        mDataSet.push({ Name: "Ref", Value: mResult.FILEREF, Path: "" });
        mDataSet.push({ Name: "File Title", Value: mResult.TITLE, Path: "" });
        var mPath = mResult.URL;
        mDataSet.push({
          Name: "Hotlink",
          Value: (
            <a href={DownloadFromWebAPI(mPath)} target="_blank">
              Open PDF
            </a>
          ),
          Path: mPath,
        });
      }

      mDataSet.push({
        Name: "Easting",
        Value: pGraphic.attributes["EASTING"],
        Path: "",
      });
      mDataSet.push({
        Name: "Northing",
        Value: pGraphic.attributes["NORTHING"],
        Path: "",
      });
      return mDataSet;
    },
  },
  {
    name: "DH Orders",
    layer: "SlopeInfo",
    layerId: 8,
    itemDetailType: "API",
    srvEndPt: "DHOrder",
    queryValue: "DH_ORDER",

    aliasList: [
      { Name: "Order No", Value: "ORDER_NO" },
      { Name: "Type", Value: "ORDER_TYPE" },
      { Name: "Issue Dept", Value: "ISSUE_DEPT" },
      { Name: "BD File", Value: "BD_FILE" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Issue Date", Value: "ISSUE_DATE" },
      { Name: "Commencement Date", Value: "COMM_DATE" },
      { Name: "Completion Date", Value: "COMP_DATE" },
      { Name: "Order Status", Value: "STATUS" },
      { Name: "Remarks", Value: "REMARKS" },
      { Name: "Appeal Case", Value: "APPCASE" },
      { Name: "Last Update Date", Value: "LASTUPDATEDATE" },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
      {
        Name: "Hotlink",
        Value: "FILEREF",
        HideNull: true,
        format: (v, r) => (
          <a href={v} target="_blank">
            Open
          </a>
        ),
      },
    ],
    attrTransform: (mResult, attributes) => {
      let pGraphic = { attributes };
      let mDataSet = [
        { Name: "Order No", Value: mResult.ORDER_NO, Path: "" },
        { Name: "Type", Value: mResult.ORDER_TYPE, Path: "" },
        { Name: "Issue Dept", Value: mResult.ISSUE_DEPT, Path: "" },
        { Name: "BD File", Value: mResult.BD_FILE, Path: "" },
        { Name: "Location", Value: mResult.LOCATION, Path: "" },
        { Name: "Issue Date", Value: mResult.ISSUE_DATE, Path: "" },
        { Name: "Commencement Date", Value: mResult.COMM_DATE, Path: "" },
        { Name: "Completion Date", Value: mResult.COMP_DATE, Path: "" },
        { Name: "Order Status", Value: mResult.STATUS, Path: "" },
        { Name: "Remarks", Value: mResult.REMARKS, Path: "" },
        { Name: "Appeal Case", Value: mResult.APPCASE, Path: "" },
        { Name: "Last Update Date", Value: mResult.LASTUPDATEDATE, Path: "" },
        { Name: "Easting", Value: pGraphic.attributes["EASTING"], Path: "" },
        { Name: "Northing", Value: pGraphic.attributes["NORTHING"], Path: "" },
      ];

      var mDHFiles = mResult.DHFiles;
      for (var i = 0; i < mDHFiles.length; i++) {
        var mDHFile = mDHFiles[i];
        var mPath = mDHFile.URL;
        var mDataPDF = {
          Name: "Hotlink",
          Value: (
            <a href={mPath} target="_blank">
              {DownloadFromWebAPI(mDHFile.FILEREF)}
            </a>
          ),
        };
        mDataSet.push(mDataPDF);
      }
      return mDataSet;
    },
  },
  {
    name: "District Engineer Area",
    layer: "SlopeInfo",
    layerId: 56,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Area", Value: "AREA" },
      { Name: "Section", Value: "SECTION" },
      { Name: "GE Name", Value: "GE_NAME" },
      { Name: "GE Post", Value: "GE_POST" },
      { Name: "GE Telephone", Value: "GE_TEL" },
      { Name: "GE Email", Value: "GE_EMAIL" },
      { Name: "SGE Name", Value: "SGE_NAME" },
      { Name: "SGE Post", Value: "SGE_POST" },
      { Name: "SGE Telephone", Value: "SGE_TEL" },
      { Name: "SGE Email", Value: "SGE_EMAIL" },
      { Name: "CGE Name", Value: "CGE_NAME" },
      { Name: "CGE Post", Value: "CGE_POST" },
      { Name: "CGE Email", Value: "CGE_EMAIL" },
    ],
  },
  {
    name: "Disused Tunnel",
    layer: "SlopeInfo",
    layerId: 61,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "File No.", Value: "File_No" },
      { Name: "Place", Value: "Location" },
      { Name: "Network No.", Value: "Network_No" },
    ],
  },
  {
    name: "Drainage and Sewage Tunnel Protection Zone",
    layer: "SlopeInfo",
    layerId: 62,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "Drainage and Sewage Tunnel Protection Zone",
    aliasList: [{ Name: "Name", Value: "Tunnel_Nam" }],
  },
  {
    name: "Emergency Works Services",
    layer: "SlopeInfo",
    layerId: 33,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "LPM Emergency Works Services",
    aliasList: [
      { Name: "Area", Value: "Area" },
      {
        Name: "EWS Period",
        Value: "EWS_From",
        format: (v, r) =>
          moment(v).format("DD/MM/YYYY") +
          " - " +
          moment(r.EWS_To).format("DD/MM/YYYY"),
      },
      { Name: "Agreement No.", Value: "Agreement" },
      { Name: "Works Contract No.", Value: "Contract" },
      { Name: "Contract Commencement Date", Value: "C_Commence" },
      {
        Name: "Anticipated Contract Completion Date",
        Value: "C_Complete",
      },
      { Name: "Consultant", Value: "Consultant" },
      { Name: "PE", Value: "PE" },
      { Name: "SGE", Value: "SGE" },
      { Name: "CGE", Value: "CGE" },
      { Name: "Backup Agreement", Value: "Backup_Agr" },
    ],
  },
  {
    name: "ENTLI Crown (2019)",
    layer: "SlopeInfo",
    layerId: 35,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "ENTLI Crown / Trail",
    aliasList: [
      { Name: "ENTLI No.", Value: "ENTLI_NO" },
      { Name: "Slide ID", Value: "SLIDE_ID" },
      {
        Name: "Type of slides",
        Value: "SLIDE_TYPE",
        format: (mSlideType) => {
          switch (mSlideType) {
            case "R":
              mSlideType = "Relict";
              break;
            case "O":
              mSlideType = "Recent open hillside";
              break;
            case "C":
              mSlideType = "Recent debris flow";
              break;
            case "S":
              mSlideType = "Coastal landslide";
              break;
          }
          return mSlideType;
        },
      },
      { Name: "Action", Value: "ACTION" },
      { Name: "Width of main scarp", Value: "M_WIDTH" },
      { Name: "Length of landslide source", Value: "S_LENGTH" },
      { Name: "Slope", Value: "SLOPE" },
      {
        Name: "Vegetation cover",
        Value: "COVER",
        format: (mCover) => {
          switch (mCover) {
            case "A":
              mCover = "Totally bare";
              break;
            case "B":
              mCover = "Partially bare";
              break;
            case "C":
              mCover = "Completely in grass";
              break;
            case "D":
              mCover = "Shrubs and trees";
              break;
          }
          return mCover;
        },
      },
      { Name: "Year landslide first observed", Value: "YEAR_1" },
      { Name: "Elevation of landslide crown", Value: "HEADELEV" },
      { Name: "Elevation of landslide toe", Value: "TAILELEV" },
      { Name: "Elevation difference of landslide trail", Value: "ELE_DIFF" },
      { Name: "Gully", Value: "GULLY" },
      {
        Name: "Relict class",
        Value: "CLASS",
        format: (mClass) => {
          switch (mClass) {
            case "A1":
              mClass = "Debris relating to source evident (80% certain)";
              break;
            case "A2":
              mClass = "Scarp predominantly sharp (80% certain)";
              break;
            case "B1":
              mClass = "Scarp predominantly rounded (50% certain)";
              break;
            case "B2":
              mClass =
                "Rock scarp beyond which scarp predominantly rounded (50% certain)";
              break;
            case "C1":
              mClass = "Depression related to drainage line (10% certain)";
              break;
            case "C2":
              mClass = "Broad depression (10% certain)";
              break;
            case "S":
              mClass = "Coastal landslide";
              break;
          }
          return mClass;
        },
      },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
    ],
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch)
        sb.push(
          "ENTLI NO,Type of slides,Width of main scarp,Length of landslide source,Slope,Vegetation Cover,Year landslide first observed,Elevation of landslide crown,Elevation of landslide toe,Relict class"
        );

      mData.forEach((mGraphic) => {
        var mENTLI_NO = mGraphic.attributes.ENTLI_NO;
        var mSLIDE_TYPE = mGraphic.attributes.SLIDE_TYPE;
        var mM_WIDTH = mGraphic.attributes.M_WIDTH;
        var mS_LENGTH = mGraphic.attributes.S_LENGTH;
        var mSLOPE = mGraphic.attributes.SLOPE;
        var mCOVER = mGraphic.attributes.COVER;
        var mYEAR_1 = mGraphic.attributes.YEAR_1;
        var mHEADELEV = mGraphic.attributes.HEADELEV;
        var mTAILELEV = mGraphic.attributes.TAILELEV;
        var mCLASS = mGraphic.attributes.CLASS;

        switch (mSLIDE_TYPE) {
          case "R":
            mSLIDE_TYPE = "Relict";
            break;
          case "O":
            mSLIDE_TYPE = "Recent open hillside";
            break;
          case "C":
            mSLIDE_TYPE = "Recent debris flow";
            break;
          case "S":
            mSLIDE_TYPE = "Coastal landslide";
            break;
        }

        switch (mCOVER) {
          case "A":
            mCOVER = "Totally bare";
            break;
          case "B":
            mCOVER = "Partially bare";
            break;
          case "C":
            mCOVER = "Completely in grass";
            break;
          case "D":
            mCOVER = "Shrubs and trees";
            break;
        }

        switch (mCLASS) {
          case "A1":
            mCLASS = "Debris relating to source evident (80% certain)";
            break;
          case "A2":
            mCLASS = "Scarp predominantly sharp (80% certain)";
            break;
          case "B1":
            mCLASS = "Scarp predominantly rounded (50% certain)";
            break;
          case "B2":
            mCLASS =
              "Rock scarp beyond which scarp predominantly rounded (50% certain)";
            break;
          case "C1":
            mCLASS = "Depression related to drainage line (10% certain)";
            break;
          case "C2":
            mCLASS = "Broad depression (10% certain)";
            break;
          case "S":
            mCLASS = "Coastal landslide";
            break;
        }

        sb.push(
          mENTLI_NO +
            "," +
            mSLIDE_TYPE +
            "," +
            mM_WIDTH +
            "," +
            mS_LENGTH +
            "," +
            mSLOPE +
            "," +
            mCOVER +
            "," +
            mYEAR_1 +
            "," +
            mHEADELEV +
            "," +
            mTAILELEV +
            "," +
            mCLASS
        );
      });
    },
  },
  {
    name: "ENTLI Trail (2019)",
    layer: "SlopeInfo",
    layerId: 36,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "ENTLI Crown / Trail",
    aliasList: [
      { Name: "ENTLI No.", Value: "ENTLI_NO" },
      { Name: "Slide ID", Value: "SLIDE_ID" },
      {
        Name: "Type of slides",
        Value: "SLIDE_TYPE",
        format: (mSlideType) => {
          switch (mSlideType) {
            case "R":
              mSlideType = "Relict";
              break;
            case "O":
              mSlideType = "Recent open hillside";
              break;
            case "C":
              mSlideType = "Recent debris flow";
              break;
            case "S":
              mSlideType = "Coastal landslide";
              break;
          }
          return mSlideType;
        },
      },
      { Name: "Action", Value: "ACTION" },
      { Name: "Width of main scarp", Value: "M_WIDTH" },
      { Name: "Length of landslide source", Value: "S_LENGTH" },
      { Name: "Slope", Value: "SLOPE" },
      {
        Name: "Vegetation cover",
        Value: "COVER",
        format: (mCover) => {
          switch (mCover) {
            case "A":
              mCover = "Totally bare";
              break;
            case "B":
              mCover = "Partially bare";
              break;
            case "C":
              mCover = "Completely in grass";
              break;
            case "D":
              mCover = "Shrubs and trees";
              break;
          }
          return mCover;
        },
      },
      { Name: "Year landslide first observed", Value: "YEAR_1" },
      { Name: "Elevation of landslide crown", Value: "HEADELEV" },
      { Name: "Elevation of landslide toe", Value: "TAILELEV" },
      { Name: "Elevation difference of landslide trail", Value: "ELE_DIFF" },
      { Name: "Gully", Value: "GULLY" },
      {
        Name: "Relict class",
        Value: "CLASS",
        format: (mClass) => {
          switch (mClass) {
            case "A1":
              mClass = "Debris relating to source evident (80% certain)";
              break;
            case "A2":
              mClass = "Scarp predominantly sharp (80% certain)";
              break;
            case "B1":
              mClass = "Scarp predominantly rounded (50% certain)";
              break;
            case "B2":
              mClass =
                "Rock scarp beyond which scarp predominantly rounded (50% certain)";
              break;
            case "C1":
              mClass = "Depression related to drainage line (10% certain)";
              break;
            case "C2":
              mClass = "Broad depression (10% certain)";
              break;
            case "S":
              mClass = "Coastal landslide";
              break;
          }
          return mClass;
        },
      },
      { Name: "Easting", Value: "EASTING" },
      { Name: "Northing", Value: "NORTHING" },
    ],
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch)
        sb.push(
          "ENTLI NO,Type of slides,Width of main scarp,Length of landslide source,Slope,Vegetation Cover,Year landslide first observed,Elevation of landslide crown,Elevation of landslide toe,Relict class"
        );

      mData.forEach((mGraphic) => {
        var mENTLI_NO = mGraphic.attributes.ENTLI_NO;
        var mSLIDE_TYPE = mGraphic.attributes.SLIDE_TYPE;
        var mM_WIDTH = mGraphic.attributes.M_WIDTH;
        var mS_LENGTH = mGraphic.attributes.S_LENGTH;
        var mSLOPE = mGraphic.attributes.SLOPE;
        var mCOVER = mGraphic.attributes.COVER;
        var mYEAR_1 = mGraphic.attributes.YEAR_1;
        var mHEADELEV = mGraphic.attributes.HEADELEV;
        var mTAILELEV = mGraphic.attributes.TAILELEV;
        var mCLASS = mGraphic.attributes.CLASS;

        switch (mSLIDE_TYPE) {
          case "R":
            mSLIDE_TYPE = "Relict";
            break;
          case "O":
            mSLIDE_TYPE = "Recent open hillside";
            break;
          case "C":
            mSLIDE_TYPE = "Recent debris flow";
            break;
          case "S":
            mSLIDE_TYPE = "Coastal landslide";
            break;
        }

        switch (mCOVER) {
          case "A":
            mCOVER = "Totally bare";
            break;
          case "B":
            mCOVER = "Partially bare";
            break;
          case "C":
            mCOVER = "Completely in grass";
            break;
          case "D":
            mCOVER = "Shrubs and trees";
            break;
        }

        switch (mCLASS) {
          case "A1":
            mCLASS = "Debris relating to source evident (80% certain)";
            break;
          case "A2":
            mCLASS = "Scarp predominantly sharp (80% certain)";
            break;
          case "B1":
            mCLASS = "Scarp predominantly rounded (50% certain)";
            break;
          case "B2":
            mCLASS =
              "Rock scarp beyond which scarp predominantly rounded (50% certain)";
            break;
          case "C1":
            mCLASS = "Depression related to drainage line (10% certain)";
            break;
          case "C2":
            mCLASS = "Broad depression (10% certain)";
            break;
          case "S":
            mCLASS = "Coastal landslide";
            break;
        }

        sb.push(
          mENTLI_NO +
            "," +
            mSLIDE_TYPE +
            "," +
            mM_WIDTH +
            "," +
            mS_LENGTH +
            "," +
            mSLOPE +
            "," +
            mCOVER +
            "," +
            mYEAR_1 +
            "," +
            mHEADELEV +
            "," +
            mTAILELEV +
            "," +
            mCLASS
        );
      });
    },
  },
  {
    name: "Feature Status Review (FSR)",
    layer: "SlopeInfo",
    layerId: 4,
    itemDetailType: "API",
    srvEndPt: "FSR",
    queryValue: "SCS_ID",

    aliasList: [],
    attrTransform: (mResult) => {
      {
        let mDataSet = [
          { Name: "SCS ID", Value: mResult.SCS_ID, Path: "" },
          { Name: "SIS Feature", Value: mResult.FK_SIS_FEATURE, Path: "" },
          { Name: "SCS Feature", Value: mResult.FEATURE, Path: "" },
          { Name: "SCS Part", Value: mResult.PART, Path: "" },
          { Name: "SCS Status", Value: mResult.SCS_STATUS, Path: "" },
          { Name: "FSR Status", Value: mResult.FK_CHECKING_STATUS, Path: "" },
          { Name: "Feature Remark", Value: mResult.FEA_REMARKS, Path: "" },
          { Name: "Feature Action", Value: mResult.ACTIONS, Path: "" },
          { Name: "Reviewer", Value: mResult.GENAME, Path: "" },
          {
            Name: "Last Update",
            Value: mResult.FEATURE_LASTUPDATEDATE,
            Path: "",
          },
          { Name: "File Ref", Value: mResult.FILE_ID, Path: "" },
          { Name: "File Title", Value: mResult.TITLE, Path: "" },
          { Name: "Project Type", Value: mResult.BPUBLIC, Path: "" },
          { Name: "File Remark", Value: mResult.FIL_REMARKS, Path: "" },
          { Name: "Relevant File", Value: mResult.RELEFILES, Path: "" },
          { Name: "Easting", Value: mResult.EASTING, Path: "" },
          { Name: "Northing", Value: mResult.NORTHING, Path: "" },
        ];

        var mSLOPE_LOCATION_PLANs = mResult.SLOPE_LOCATION_PLANs;
        for (let i = 0; i < mSLOPE_LOCATION_PLANs.length; i++) {
          var mSLOPE_LOCATION_PLAN = mSLOPE_LOCATION_PLANs[i];
          let mPath = DownloadFromWebAPI(mSLOPE_LOCATION_PLAN.URL);
          var mDataSLP = {
            Name: "Hotlink",
            Value: (
              <a href={mPath} target="_blank">
                Slope Location Plan
              </a>
            ),
          };
          mDataSet.push(mDataSLP);
        }

        var mPDFs = mResult.PDFs;
        for (let i = 0; i < mPDFs.length; i++) {
          var mPDF = mPDFs[i];
          let mPath = DownloadFromWebAPI(mPDF.URL);
          var mDataPDF = {
            Name: "Hotlink",
            Value: (
              <a href={mPath} target="_blank">
                PDF
              </a>
            ),
          };
          mDataSet.push(mDataPDF);
        }
        return mDataSet;
      }
    },
  },
  {
    name: "GCC Cases",
    layer: "SlopeInfo",
    layerId: 15,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "GCC Case No.", Value: "GCC_CASE" },
      { Name: "File Reference", Value: "FILEREF" },
      { Name: "Part", Value: "PART" },
      { Name: "Folio", Value: "FOLIO" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Area Code", Value: "AREA_CODE" },
    ],
  },
  {
    name: "GI Location",
    itemDetailType: "gireport",
    resultItemFormatter: (row) =>
      `${row["Station.REPNO"]}, ${row["Station.STATNO"]}, ${
        row["Station.STATTYPE"]
      }`,
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch)
        sb.push(
          "REPORT_NO,STATION_NO,STATION_TYPE,WORK_ORDER_NO,CONTRACT,TITLE,AUTHOR,REPORT_TYPE,CLASSIFICATION"
        );

      for (var i = 0; i < mData.length; i++) {
        let newAttr = {};
        Object.keys(mData[i].attributes).forEach((j) => {
          let newKey = j.substring(j.lastIndexOf(".") + 1);
          newAttr[newKey] = mData[i].attributes[j];
        });
        var mGraphic = { attributes: newAttr };

        var mREPORT_NO = mGraphic.attributes.REPNO;
        var mSTATION_NO = mGraphic.attributes.STATNO;
        var mSTATION_TYPE = mGraphic.attributes.STATTYPE;
        var mWORK_ORDER_NO = mGraphic.attributes.WORKNO;
        var mCONTRACT = mGraphic.attributes.CONTRACT;
        var mTITLE = mGraphic.attributes.TITLE;
        var mAUTHOR = mGraphic.attributes.AUTHOR;
        var mREPORT_TYPE = mGraphic.attributes.REPTYPE;
        var mCLASSIFICATION = mGraphic.attributes.REPCLASS;

        sb.push(
          mREPORT_NO +
            ',"' +
            mSTATION_NO +
            '",' +
            mSTATION_TYPE +
            "," +
            mWORK_ORDER_NO +
            "," +
            mCONTRACT +
            ',"' +
            mTITLE +
            '","' +
            mAUTHOR +
            '",' +
            mREPORT_TYPE +
            "," +
            mCLASSIFICATION
        );
      }
    },
  },
  {
    name: "GIU Report",
    type: "giureport",
    itemDetailType: "gireport",
    layer: "../Overlay/GIU1KCellRef_D9",
    layerId: 0,
    displayField: "REPNO",
    resultItemFormatter: (row) =>
      row.REPNO !== "DUMMY_CELL" && (
        <div>
          Report No. : {row.REPNO} <br />
          Title : {row.TITLE} <br />
          Type : {row.REPTYPE} <br />
          Author : {row.AUTHOR} <br />
          Works No. : {row.WORKNO} <br />
          Contract No. : {row.CONTRACT}
        </div>
      ),
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch) sb.push("REPORT_NO,TITLE,TYPE,AUTHOR,WORKNO,CONTRACT");

      for (var i = 0; i < mData.length; i++) {
        let newAttr = {};
        Object.keys(mData[i].attributes).forEach((j) => {
          let newKey = j.substring(j.lastIndexOf(".") + 1);
          newAttr[newKey] = mData[i].attributes[j];
        });
        var mGraphic = { attributes: newAttr };
        var mREPORT_NO = mGraphic.attributes.REPNO;
        var mTITLE = mGraphic.attributes.TITLE;
        var mTYPE = mGraphic.attributes.REPTYPE;
        var mAUTHOR = mGraphic.attributes.AUTHOR;
        var mWORKNO = mGraphic.attributes.WORKNO;
        var mCONTRACT = mGraphic.attributes.CONTRACT;

        if (mREPORT_NO === "DUMMY_CELL") continue;

        sb.push(
          mREPORT_NO +
            ',"' +
            mTITLE +
            '",' +
            mTYPE +
            ',"' +
            mAUTHOR +
            '","' +
            mWORKNO +
            '","' +
            mCONTRACT +
            '"'
        );
      }
    },
  },
  {
    name: "Ground Anchor",
    layer: "SlopeInfo",
    layerId: 17,
    itemDetailType: "API",
    srvEndPt: "GroundAnchor",
    queryValue: "PK_ID",

    aliasList: [
      { Name: "Ground Anchor", Value: "PK_ID" },
      { Name: "District", Value: "FK_DISTRICT" },
      { Name: "Section", Value: "FK_SECTION" },
      { Name: "Area Code", Value: "FK_AREA" },
      { Name: "GE", Value: "GENAME" },
      { Name: "Feature No.", Value: "FEATURE" },
      { Name: "Anchors in Service?", Value: "ANCHORSERVICE" },
      { Name: "Service Details", Value: "SERVICEDETAIL" },
      { Name: "Address", Value: "ADDRESS" },
      { Name: "Maintenance Party", Value: "MAINTENPARTY" },
      { Name: "Easting", Value: "COORDIN_EAST" },
      { Name: "Northing", Value: "COORDIN_NORTH" },
      { Name: "Evidence of GEO Checking?", Value: "EVIDENCECHECK" },
      { Name: "Evidence Reference", Value: "EVIDENCEREFER" },
      { Name: "Consequence Category", Value: "CONSEQCAT" },
      { Name: "Old Anchor? (GCC Paper No. 172)", Value: "OLDANCHOR" },
      { Name: "Slope Exist", Value: "SLOPE_EXIST" },
      { Name: "Slope Height (m)", Value: "SLOPE_HEIGHT" },
      { Name: "Slope Width (m)", Value: "SLOPE_WIDTH" },
      { Name: "Slope Angle (deg.)", Value: "SLOPE_ANGLE" },
      { Name: "Wall Exist", Value: "WALL_EXIST" },
      { Name: "Wall Height (m)", Value: "WALL_HEIGHT" },
      { Name: "Wall Width (m)", Value: "WALL_WIDTH" },
      { Name: "Monitoring Data in", Value: "MONITORDATA" },
      { Name: "Other Related Files 1", Value: "OTHERRELATE1" },
      { Name: "Other Related Files 2", Value: "OTHERRELATE2" },
      { Name: "Other Related Files 3", Value: "OTHERRELATE3" },
      { Name: "Other Related Files 4", Value: "OTHERRELATE4" },
      { Name: "Visual Inspection", Value: "VISUAL_INSPECT" },
      { Name: "Visual Inspection Period (months)", Value: "V_INSPECTPERIOD" },
      { Name: "Maintenance Inspection", Value: "MAIN_INSPECT" },
      {
        Name: "Maintenance Inspection Period (months)",
        Value: "M_INSPECTPERIOD",
      },
      { Name: "Grease Test", Value: "GREASE_TEST" },
      { Name: "Grease Test Period (months)", Value: "GREASEPERIOD" },
      { Name: "Lift-off Test", Value: "LIFTOFF_TEST" },
      { Name: "Lift-off Test Period (months)", Value: "LIFTOFFPERIOD" },
      {
        Name: "No. of Anchors to be Lift-off in a Test",
        Value: "NOANCHORLIFTOFF",
      },
      { Name: "Other Type of Monitoring", Value: "OTHER_TYPE" },
      {
        Name: "Other Type of Monitoring Period (months)",
        Value: "OTHERTYPEPERIOD",
      },
      { Name: "Monitoring Details", Value: "MONDETAIL" },
      { Name: "Remarks", Value: "REMARKS" },
      { Name: "No. of Anchors", Value: "NO_ANCHOR" },
      { Name: "Installation in (MM/YYYY)", Value: "INSTALL_IN" },
      { Name: "Anchor Type", Value: "TYPE_DESCRIPTION" },
      { Name: "Other Anchor Type", Value: "ANCHORTYPE_OTHER" },
      { Name: "Anchor Brand", Value: "BRAND_DESCRIPTION" },
      { Name: "Other Anchor Brand", Value: "ANCHORBRAND_OTHER" },
      { Name: "Corrosion Protection", Value: "CORR_DESCRIPTION" },
      { Name: "Suitability Test", Value: "SUIT_TEST_DESCRIPTION" },
      { Name: "Residual Load Measureable?", Value: "RESIDUALLOAD" },
      {
        Name: "Ext. Acceptance/Acceptance Test",
        Value: "ACCEPT_TEST_DESCRIPTION",
      },
      { Name: "Design Working Load (kN) from", Value: "DESIGNWLOADFROM" },
      { Name: "Design Working Load (kN) to", Value: "DESIGNWLOADTO" },
      { Name: "Initial Lock-off Load (kN) from", Value: "INITIALLLOADFROM" },
      { Name: "Initial Lock-off Load (kN) to", Value: "INITIALLLOADTO" },
    ],
  },
  {
    name: "Hillside Pocket",
    layer: "SlopeInfo",
    layerId: 42,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "Hillside Pocket Catalogue (HPC)",
    aliasList: [
      { Name: "Hillside Pocket No.", Value: "HP_NO" },
      { Name: "The plan area of the Hillside Pocket (m2)", Value: "Plan_Area" },
      {
        Name: "The maximum elevation difference of the hillside pocket (m)",
        Value: "Max_ED",
      },
    ],
  },
  {
    name: "Historical Landslide Catchment (2016)",
    layer: "SlopeInfo",
    layerId: 41,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Catchment No.", Value: "CATCH_NO" },
      { Name: "Plan area of the catchment (Sq. m)", Value: "CATCH_AREA" },
      { Name: "Maximum elevation difference (m)", Value: "C_MAX_ED" },
      {
        Name:
          "The plan area of the catchment with gradient less than 15 degree (Sq. m)",
        Value: "AREA_15DEG",
      },
      { Name: "Site visit for the catchment", Value: "SITE_VISIT" },
      {
        Name: "Total number of relict ENTLI records within the catchment",
        Value: "NO_RELICT",
      },
      {
        Name: "Total number of recent ENTLI records within the catchment",
        Value: "NO_RECENT",
      },
      {
        Name:
          "The length of the longest relict ENTLI record within the catchment (m)",
        Value: "M_RELICT_L",
      },
      {
        Name:
          "The length of the longest recent ENTLI record within the catchment (m)",
        Value: "M_RECENT_L",
      },
      {
        Name: "The length of the longest ENTLI record within the catchment (m)",
        Value: "MAX_TRAIL",
      },
      {
        Name:
          "The total length of the all ENTLI record within the catchment (m)",
        Value: "SUM_LENGTH",
      },
    ],
  },
  {
    name: "Horizontal Drain",
    layer: "SlopeInfo",
    layerId: 18,
    itemDetailType: "API",
    srvEndPt: "HorizontalDrain",
    queryValue: "TAGMARK",

    aliasList: [
      { Name: "Ref", Value: "REF" },
      { Name: "Features", Value: "FEATURE" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Length", Value: "LENGTH" },
      { Name: "Height", Value: "HEIGHT" },
      { Name: "Construction Date", Value: "CONS_DATE" },
      { Name: "Remarks", Value: "REMARKS" },
      { Name: "Type1", Value: "TYPE1" },
      { Name: "Type2", Value: "TYPE2" },
    ],
  },
  {
    name: "Incidents (Confirmed Cases)",
    layer: "SlopeInfo",
    layerId: 38,
    itemDetailType: "API",
    srvEndPt: "IncidentReports",
    queryValue: "INCID",
    allowSavePdf: "Incident",
    aliasList: [],
    attrTransform: function(mResults, attributes) {
      let pGraphic = { attributes };
      let mDataSet = [
        {
          Name: "GEO Incident No.",
          Value: pGraphic.attributes["INCID"],
          Files: "",
        },
        { Name: "Location", Value: pGraphic.attributes["LOCATION"], Files: "" },
        {
          Name: "Feature Type",
          Value: pGraphic.attributes["FEATTYPE"],
          Files: "",
        },
        {
          Name: "Failure Volume",
          Value: pGraphic.attributes["SCALE"],
          Files: "",
        },
        { Name: "Remarks", Value: pGraphic.attributes["REMARK"], Files: "" },
        {
          Name:
            "Original incident number assigned by Other Government Departments (OGD)",
          Value: pGraphic.attributes["OGDINCID"],
          Files: "",
        },
      ];

      if (mResults.length > 0) {
        var mData = {
          Name: "Report",
          Value: (
            <a
              href={
                "/GInfoMap/openIncidentPDF.aspx?files=" +
                JSON.stringify(mResults)
              }
              target="_blank"
            >
              Open
            </a>
          ),
        };
        mDataSet.push(mData);
      }
      return mDataSet;
    },
  },
  {
    name: "Incidents (To be confirmed by LIC)",
    layer: "SlopeInfo",
    layerId: 39,
    itemDetailType: "API",
    srvEndPt: "IncidentToBeConfirmed",
    queryValue: "Incident",
    allowSavePdf: "Incident to be confirmed",
    aliasList: [
      { Name: "GEO Incident No.", Value: "INCNO" },
      { Name: "Location", Value: "LOCATION" },
      { Name: "Feature Type", Value: "FEATURETYPE" },
      { Name: "Debris Volume", Value: "DEBRISVOLUME" },
      { Name: "Remarks", Value: "INCIDENTTYPEREMARKS" },
      {
        Name: "Report",
        Value: "URLs",
        format: (v, r) => {
          let tmpDIVDOM = document.createElement("DIV");
          v.forEach((url, index) => {
            let span = document.createElement("span");
            let a = document.createElement("a");
            let br = document.createElement("br");
            span.innerHTML = `${index + 1}: `;
            a.href = url.URL;
            a.innerHTML = " Open ";
            a.target = "_blank";
            span.appendChild(a);
            tmpDIVDOM.appendChild(span);
            tmpDIVDOM.appendChild(br);
          });
          return tmpDIVDOM;
        },
      },
    ],
  },
  {
    name: "Issued DBEL",
    layer: "SlopeInfo",
    layerId: 60,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    allowSavePdf: "Bulk Excavation Limit",
    aliasList: [
      { Name: "DBEL No.", Value: "DBEL_NO_", FileName: "" },
      { Name: "BD Ref.", Value: "REF", FileName: "" },
      { Name: "Easting", Value: "EASTING", FileName: "" },
      { Name: "Northing", Value: "NORTHING", FileName: "" },
      {
        Name: "Hotlink",
        Value: "DBEL_NO_",
        format: (v, r) => (
          <a
            href={DownloadFromWebAPI(["esfsshare1", `DBEL/${v}.pdf`])}
            target="_blank"
          >
            Open: PDF
          </a>
        ),
      },
    ],
  },
  {
    name: "Land Matter",
    layer: "SlopeInfo",
    layerId: 20,
    itemDetailType: "API",
    srvEndPt: "LandMatter",
    queryValue: "REF",

    aliasList: [],
    attrTransform: (mResult) => {
      let mDataSet = [];
      for (let i = 0; i < mResult.DLCs.length; i++) {
        var mDLC = mResult.DLCs[i];
        mDataSet.push({
          Name: <span style={attrTitleStyle}>DLC Tagmark</span>,
          Value: <span style={attrTitleStyle}> {mDLC.TAG_MARK}</span>,
          Path: "",
        });
        mDataSet.push({ Name: "File No", Value: mDLC.FILE_NO, Path: "" });
        mDataSet.push({ Name: "Part", Value: mDLC.PART, Path: "" });
        mDataSet.push({ Name: "Folio", Value: mDLC.FOLIO, Path: "" });
        mDataSet.push({
          Name: "Reference",
          Value: mDLC.DLO_REFERENCE,
          Path: "",
        });
        mDataSet.push({ Name: "Location", Value: mDLC.LOCATION, Path: "" });
        if (mDLC.URL != "N/A") {
          mDataSet.push({
            Name: "Hotlink",
            Value: (
              <a href={DownloadFromWebAPI(mDLC.URL)} target="blank">
                Open Link
              </a>
            ),
          });
        }
        mDataSet.push({ Name: " ", Value: "", Path: "" });
      }

      for (let i = 0; i < mResult.LAs.length; i++) {
        var mLA = mResult.LAs[i];
        mDataSet.push({
          Name: <span style={attrTitleStyle}>LA Tagmark</span>,
          Value: <span style={attrTitleStyle}>{mLA.TAGMARK}</span>,
          Path: "",
        });
        mDataSet.push({ Name: "File No", Value: mLA.FILE_NO, Path: "" });
        mDataSet.push({ Name: "Part", Value: mLA.PART, Path: "" });
        mDataSet.push({ Name: "Folio", Value: mLA.FOLIO, Path: "" });
        mDataSet.push({
          Name: "Reference",
          Value: mLA.DLC_REFERENCE,
          Path: "",
        });
        mDataSet.push({ Name: "Location", Value: mLA.LOCATION, Path: "" });
        if (mLA.URL != "N/A") {
          mDataSet.push({
            Name: "Hotlink",
            Value: (
              <a href={DownloadFromWebAPI(mLA.URL)} target="blank">
                Open Link
              </a>
            ),
          });
        }
        mDataSet.push({ Name: " ", Value: "", Path: "" });
      }

      for (let i = 0; i < mResult.BCFiles.length; i++) {
        var mBCFile = mResult.BCFiles[i];
        mDataSet.push({
          Name: <span style={attrTitleStyle}>BC File Tagmark</span>,
          Value: <span style={attrTitleStyle}> {mBCFile.DIS_TAGMARK}</span>,
          Path: "",
        });
        mDataSet.push({ Name: "Division", Value: mBCFile.DIVISION, Path: "" });
        mDataSet.push({ Name: "File Ref", Value: mBCFile.FILEREF, Path: "" });
        mDataSet.push({ Name: "Code", Value: mBCFile.CODE, Path: "" });
        mDataSet.push({ Name: "Subcode", Value: mBCFile.SUBCODE, Path: "" });
        mDataSet.push({ Name: "Serial", Value: mBCFile.SERIAL, Path: "" });
        mDataSet.push({ Name: "Part", Value: mBCFile.PART, Path: "" });
        mDataSet.push({ Name: "Folio", Value: mBCFile.FOLIO, Path: "" });
        mDataSet.push({ Name: "Doc Type", Value: mBCFile.DOC_TYPE, Path: "" });
        mDataSet.push({ Name: "Title", Value: mBCFile.TITLE, Path: "" });
        if (mBCFile.URL != "N/A") {
          mDataSet.push({
            Name: "Hotlink",
            Value: (
              <a href={DownloadFromWebAPI(mBCFile.URL)} target="blank">
                Open Link
              </a>
            ),
          });
        }
        mDataSet.push({ Name: " ", Value: "", Path: "" });
      }

      if (mDataSet.length === 0) return [{ name: "No Data" }];
      else return mDataSet;
    },
  },
  {
    name: "Landslide Studies Report Areas",
    layer: "SlopeInfo",
    layerId: 37,
    itemDetailType: "attrTbl",
    aliasList: [
      { Name: "LSR Report No.", Value: "REPORT" },
      { Name: "Feature", Value: "FEATURE" },
      { Name: "File Ref.", Value: "FILE_REF" },
      { Name: "Incident", Value: "INCIDENT" },
      { Name: "Year", Value: "YEAR" },
      { Name: "GEO Report", Value: "GEO_REPORT" },
      { Name: "Consultant", Value: "CONSULTANT" },
      { Name: "Report Title", Value: "TITLE" },
    ],
  },
  {
    name: "Mitigated Hillside (MH) Features",
    layer: "SlopeInfo",
    layerId: 43,
    itemDetailType: "mms",
    srvEndPt: "",
    queryValue: "",

    aliasList: [],
  },
  {
    name: "NT Exempted House",
    layer: "SlopeInfo",
    layerId: 19,
    itemDetailType: "API",
    srvEndPt: "NTEHs",
    queryValue: "REF",

    aliasList: [],
    attrTransform: function(mResults) {
      let mDataSet = [];
      for (let i = 0; i < mResults.length; i++) {
        var mResult = mResults[i];

        mDataSet.push({
          Name: <span style={attrTitleStyle}>{mResult.TAGMARK}</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({ Name: "File No", Value: mResult.FILE_NO, Path: "" });
        mDataSet.push({ Name: "Part", Value: mResult.PART, Path: "" });
        mDataSet.push({ Name: "Folio", Value: mResult.FOLIO, Path: "" });
        mDataSet.push({
          Name: "Reference",
          Value: mResult.DLO_REFERENCE,
          Path: "",
        });
        mDataSet.push({ Name: "Location", Value: mResult.LOCATION, Path: "" });
        if (mResult.URL != "") {
          mDataSet.push({
            Name: "Hotlink",
            Value: (
              <a href={DownloadFromWebAPI(mResult.URL)} target="_blank">
                Open Link
              </a>
            ),
          });
        }
        mDataSet.push({ Name: <span />, Value: "", Path: "" });
      }
      return mDataSet;
    },
  },
  {
    name: "NTHS (District)",
    layer: "SlopeInfo",
    layerId: 20,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [],
    attrTransform: function(mResult, attributes, user, showDialog) {
      let aliasList = [
        { Name: "NTHS (District)", Value: "REF" },
        { Name: "Easting", Value: "EASTING" },
        { Name: "Northing", Value: "NORTHING" },
      ];
      aliasList.forEach((i) => {
        i.Value = mResult[i.Value];
      });
      if (user.iu === "g") {
        let ref = mResult.REF;
        ref = ref.replace("NTHS-", "");
        let link =
          "https://geointranet.cedd.hksarg/nths/Default.aspx?case=" + ref;
        aliasList.push({
          Name: "Hotlink",
          Value: (
            <a href={link} target="_blank">
              Open Link
            </a>
          ),
        });
      }

      return aliasList;
    },
  },
  {
    name: "Planning Comment (Area < 1 km2)",
    layer: "SlopeInfo",
    layerId: 1,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    resultItemFormatter: (row) => `${row.JOBNO} - ${row.JOBTYPE}`,
    aliasList: [],
    attrTransform: (mResult, attributes, user, showDialog) => {
      let attr = [
        { Name: "Job No.", Value: "JOBNO", Path: "" },
        { Name: "Job Title", Value: "JOBTITLE", Path: "" },
        { Name: "GCP Reference", Value: "GCP_REF", Path: "" },
        { Name: "Job Type", Value: "JOBTYPE", Path: "" },
        { Name: "Client", Value: "CLIENT", Path: "" },
        {
          Name: "Date of Memo",
          Value: "DATEMEMO",
          type: "date",
        },
        {
          Name: "GEO Comments Related to NT. Issue",
          Value: "NTHS_RECOM",
          Path: "",
        },
        {
          Name: "No. of NTHS Areas with Recommended Boundaries",
          Value: "NTHS_RECAR",
          Path: "",
        },
      ];
      attr.forEach(
        (i) =>
          (i.Value =
            i.type == "date"
              ? moment(attributes[i.Value]).format("DD/MM/YYYY")
              : attributes[i.Value])
      );
      if (user.userGroup === 8) {
        let jobNno = attributes.JOBNO.replace("/", "");
        attr.push({
          Name: "Internal Record Form",
          Value: (
            <a
              href={DownloadFromWebAPI([
                "pln",
                `Internal Record/${jobNno}.pdf`,
              ])}
              target="_blank"
            >
              Open
            </a>
          ),
        });
        attr.push({
          Name: "Reply Memo",
          Value: (
            <a
              href={DownloadFromWebAPI(["pln", `${jobNno}.pdf`])}
              target="_blank"
            >
              Open
            </a>
          ),
        });
      }
      return attr;
    },
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch)
        sb.push("JOBNO,JOBTITLE,GCP_REF,JOBTYPE,CLIENT,DATEMEMO");
      mData.forEach((mGraphic) => {
        var mJOBNO = mGraphic.attributes.JOBNO;
        var mJOBTITLE = mGraphic.attributes.JOBTITLE.replace(/\"/g, '""');
        var mGCP_REF = (mGraphic.attributes.GCP_REF || "").replace(
          /[\r\n]/g,
          " "
        );
        var mJOBTYPE = mGraphic.attributes.JOBTYPE;
        var mCLIENT = mGraphic.attributes.CLIENT;
        var mDATEMEMO = moment(mGraphic.attributes.DATEMEMO).format(
          "DD/MM/YYYY"
        );
        sb.push(
          mJOBNO +
            ',"' +
            mJOBTITLE +
            '",' +
            mGCP_REF +
            "," +
            mJOBTYPE +
            ',"' +
            mCLIENT +
            '",' +
            mDATEMEMO
        );
      });
    },
  },
  {
    name: "Planning Comment (Area > 1 km2)",
    layer: "SlopeInfo",
    layerId: 2,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",
    resultItemFormatter: (row) => `${row.JOBNO} - ${row.JOBTYPE}`,
    aliasList: [],
    attrTransform: (mResult, attributes, user, showDialog) => {
      let attr = [
        { Name: "Job No.", Value: "JOBNO", Path: "" },
        { Name: "Job Title", Value: "JOBTITLE", Path: "" },
        { Name: "GCP Reference", Value: "GCP_REF", Path: "" },
        { Name: "Job Type", Value: "JOBTYPE", Path: "" },
        { Name: "Client", Value: "CLIENT", Path: "" },
        {
          Name: "Date of Memo",
          Value: "DATEMEMO",
          type: "date",
        },
        {
          Name: "GEO Comments Related to NT. Issue",
          Value: "NTHS_RECOM",
          Path: "",
        },
        {
          Name: "No. of NTHS Areas with Recommended Boundaries",
          Value: "NTHS_RECAR",
          Path: "",
        },
      ];
      attr.forEach(
        (i) =>
          (i.Value =
            i.type == "date"
              ? moment(attributes[i.Value]).format("DD/MM/YYYY")
              : attributes[i.Value])
      );
      if (user.userGroup === 8) {
        let jobNno = attributes.JOBNO.replace("/", "");
        attr.push({
          Name: "Internal Record Form",
          Value: (
            <a
              href={DownloadFromWebAPI([
                "pln",
                `Internal Record/${jobNno}.pdf`,
              ])}
              target="_blank"
            >
              Open
            </a>
          ),
        });
        attr.push({
          Name: "Reply Memo",
          Value: (
            <a
              href={DownloadFromWebAPI(["pln", `${jobNno}.pdf`])}
              target="_blank"
            >
              Open
            </a>
          ),
        });
      }
      return attr;
    },
    customIdentifyExportFormat: (sb, mData, CustomSearch) => {
      if (!CustomSearch)
        sb.push("JOBNO,JOBTITLE,GCP_REF,JOBTYPE,CLIENT,DATEMEMO");
      mData.forEach((mGraphic) => {
        var mJOBNO = mGraphic.attributes.JOBNO;
        var mJOBTITLE = mGraphic.attributes.JOBTITLE.replace(/\"/g, '""');
        var mGCP_REF = (mGraphic.attributes.GCP_REF || "").replace(
          /[\r\n]/g,
          " "
        );
        var mJOBTYPE = mGraphic.attributes.JOBTYPE;
        var mCLIENT = mGraphic.attributes.CLIENT;
        var mDATEMEMO = moment(mGraphic.attributes.DATEMEMO).format(
          "DD/MM/YYYY"
        );
        sb.push(
          mJOBNO +
            ',"' +
            mJOBTITLE +
            '",' +
            mGCP_REF +
            "," +
            mJOBTYPE +
            ',"' +
            mCLIENT +
            '",' +
            mDATEMEMO
        );
      });
    },
  },
  {
    name: "Private Projects",
    layer: "SlopeInfo",
    layerId: 13,
    itemDetailType: "API",
    srvEndPt: "PrivateProject",
    queryValue: "REF",

    aliasList: [],
    attrTransform: function(mResult, attributes, user, showDialog) {
      let pGraphic = { attributes };
      let mDataSet = [];
      mDataSet.push({
        Name: "Tagmark",
        Value: pGraphic.attributes["REF"],
        Path: "",
      });
      mDataSet.push({
        Name: "Private Project",
        Value: mResult.FILEREF,
        Path: "",
      });
      mDataSet.push({
        Name: "File Title",
        Value: (
          <span>
            {mResult.TITLE1} <br /> {mResult.TITLE2}
          </span>
        ),
        Path: "",
      });

      if (mResult.PATHs.length > 0) {
        for (let i = 0; i < mResult.PATHs.length; i++) {
          var mPath = mResult.PATHs[i];
          if ([1, 2, 3, 8].includes(user.userGroup)) {
            mDataSet.push({
              Name: "Hotlink",
              Value: (
                <a href={DownloadFromWebAPI(mPath.URL)} target="_blank">
                  {mPath.FILENAME}
                </a>
              ),
            });
          } else {
            mDataSet.push({
              Name: "Hotlink",
              Value: (
                <span
                  onClick={() =>
                    showDialog({
                      isOpen: true,
                      type: "error",
                      title: "Access Denied",
                      content: "The user has no permission to open this report",
                      onDialogOk: () => {},
                    })
                  }
                >
                  {mPath.FILENAME}
                </span>
              ),
            });
          }
        }
      }

      mDataSet.push({
        Name: "Easting",
        Value: pGraphic.attributes["EASTING"],
        Path: "",
      });
      mDataSet.push({
        Name: "Northing",
        Value: pGraphic.attributes["NORTHING"],
        Path: "",
      });
      return mDataSet;
    },
  },
  {
    name: "Public Projects",
    layer: "SlopeInfo",
    layerId: 12,
    itemDetailType: "API",
    srvEndPt: "PublicProject",
    queryValue: "REF",

    aliasList: [],
    attrTransform: function(mResult, attributes, user, showDialog) {
      let pGraphic = { attributes: mResult };
      let mDataSet = [];
      mDataSet.push({
        Name: "Tagmark",
        Value: pGraphic.attributes["REF"],
        Path: "",
      });
      mDataSet.push({
        Name: "Public Project",
        Value: mResult.FILEREF,
        Path: "",
      });
      mDataSet.push({
        Name: "File Title",
        Value: (
          <span>
            {mResult.TITLE1} <br /> {mResult.TITLE2}
          </span>
        ),
        Path: "",
      });

      let checkAccessRight = function(url, hyperText) {
        if ([1, 2, 3, 8].includes(user.userGroup)) {
          mDataSet.push({
            Name: "Hotlink",
            Value: (
              <a href={DownloadFromWebAPI(url)} target="_blank">
                {hyperText}
              </a>
            ),
          });
        } else {
          mDataSet.push({
            Name: "Hotlink",
            Value: (
              <span
                onClick={() =>
                  showDialog({
                    isOpen: true,
                    type: "error",
                    title: "Access Denied",
                    content: "The user has no permission to open this report",
                    onDialogOk: () => {},
                  })
                }
              >
                {hyperText}
              </span>
            ),
          });
        }
      };

      if (mResult.PATHs.length > 0) {
        for (let i = 0; i < mResult.PATHs.length; i++) {
          var mPath = mResult.PATHs[i];
          checkAccessRight(mPath.URL, mPath.FILENAME);
        }
      }

      mDataSet.push({
        Name: "Easting",
        Value: pGraphic.attributes["EASTING"],
        Path: "",
      });
      mDataSet.push({
        Name: "Northing",
        Value: pGraphic.attributes["NORTHING"],
        Path: "",
      });

      if (mResult.SSRs.length > 0) {
        for (let i = 0; i < mResult.SSRs.length; i++) {
          if (i == 0) {
            mDataSet.push({ Name: " ", Value: "", Path: "" });
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Slope Status Review</span>,
              Value: "",
              Path: "",
            });
          }
          var mSSR = mResult.SSRs[i];
          var mPath = mSSR.URL;
          checkAccessRight(mPath, mSSR.PATH);
        }
      }
      return mDataSet;
    },
  },
  {
    name: "Registered Squatter Dwelling - with CAF in force",
    layer: "SlopeInfo",
    layerId: 2,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Dwelling No.", Value: "GEO_NDC_Dw" },
      { Name: "Clearance Application Form (CAF) No.", Value: "CAF_No" },
      { Name: "Category of NDC", Value: "NDC_Catego" },
      { Name: "Issue Date of CAF", Value: "CAF_Issue_", type: "date" },
      { Name: "Status of NDC/CAF", Value: "NDC_Recomm" },
      { Name: "Squatter Area Code", Value: "HD_Squatte" },
      { Name: "LandsD Squatter Control District", Value: "Squatter_C" },
      { Name: "GEO Subfile No.", Value: "GEO_File_R" },
      { Name: "Last Updated By GEO", Value: "Date_of_En", type: "date" },
    ],
  },
  {
    name: "Slope Checking Status (SCS)",
    layer: "SlopeInfo",
    layerId: 5,
    itemDetailType: "API",
    srvEndPt: "SCS",
    queryValue: "SCS_ID",

    aliasList: [],
    attrTransform: function(mResult) {
      let mDataSet = [
        { Name: "SCS ID", Value: "SCS_" + mResult.PK_ID, Path: "" },
        { Name: "SCS Feature", Value: mResult.FEATURE, Path: "" },
        { Name: "SCS Part", Value: mResult.PART, Path: "" },
        { Name: "SCS Status", Value: mResult.FK_STATUS, Path: "" },
        { Name: "Checking Status", Value: mResult.DESCRIPTION, Path: "" },
        { Name: "Check Cert", Value: mResult.CHECKCERT, Path: "" },
        { Name: "Feature Remark", Value: mResult.REMARKS, Path: "" },
        { Name: "Reviewer", Value: mResult.NAME, Path: "" },
        { Name: "GEO Reply", Value: mResult.GEOREPLYDATE, Path: "" },
        { Name: "Last Update", Value: mResult.LASTUPDATEDATE, Path: "" },
        { Name: "Easting", Value: mResult.EASTING, Path: "" },
        { Name: "Northing", Value: mResult.NORTHING, Path: "" },
        { Name: "---------------", Value: "---------------", Path: "" },
        { Name: "File Ref", Value: mResult.PROJECTREF, Path: "" },
        { Name: "ERKS File Ref", Value: mResult.ERKS_PROJECTREF, Path: "" },
        { Name: "File Title", Value: mResult.PROJECTTITLE, Path: "" },
        { Name: "Project Type", Value: mResult.PROJECTTYPE, Path: "" },
      ];

      if (mResult.IMAGENAMEs.length > 0) {
        for (let i = 0; i < mResult.IMAGENAMEs.length; i++) {
          var mIMAGENAME = mResult.IMAGENAMEs[i];
          mDataSet.push({
            Name: "File Ref Image",
            Value: (
              <a href={DownloadFromWebAPI(mIMAGENAME.URL)} target="_blank">
                Open Image
              </a>
            ),
          });
        }
      }
      return mDataSet;
    },
  },
  {
    name: "Squatter Structure - close to slope",
    layer: "SlopeInfo",
    layerId: 1,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Dwelling No.", Value: "GEO_NDC_Dw" },
      { Name: "Clearance Application Form (CAF) No.", Value: "CAF_No" },
      { Name: "Category of NDC", Value: "NDC_Catego" },
      { Name: "Issue Date of CAF", Value: "CAF_Issue_", type: "date" },
      { Name: "Status of NDC/CAF", Value: "NDC_Recomm" },
      { Name: "Squatter Area Code", Value: "HD_Squatte" },
      { Name: "LandsD Squatter Control District", Value: "Squatter_C" },
      { Name: "GEO Subfile No.", Value: "GEO_File_R" },
      { Name: "Last Updated By GEO", Value: "Date_of_En", type: "date" },
    ],
  },
  {
    name: "Stage 2 Study",
    layer: "SlopeInfo",
    layerId: 28,
    itemDetailType: "API",
    srvEndPt: "S23StudyWorks",
    queryValue: "SLOPE_NO",
    allowSavePdf: "LPM Stage 2 / 3 Study",
    aliasList: [],
    attrTransform: function(mResults) {
      let mDataSet = [];
      for (let i = 0; i < mResults.length; i++) {
        var mResult = mResults[i];
        mDataSet.push({
          Name: (
            <span style={attrTitleStyle}>
              LPM/LPMit Details ({mResult.AGREENO})
            </span>
          ),
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "LPM Study Feature No.",
          Value: mResult.FEATURENO,
          Path: "",
        });
        mDataSet.push({ Name: "Location", Value: mResult.LOCATION, Path: "" });
        mDataSet.push({
          Name: "District Council",
          Value: mResult.DISTRICTCOUNCIL,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Responsibility (at the time of selection)",
          Value: mResult.MR,
          Path: "",
        });
        mDataSet.push({
          Name: "Responsible Party for maintenance of Government portion",
          Value: mResult.GOV_PTY,
          Path: "",
        });
        mDataSet.push({
          Name: "Private Lot No.",
          Value: mResult.PRI_PTY,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });

        mDataSet.push({
          Name: <span style={attrTitleStyle}>LPM/LPMit Study</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Agreement No.",
          Value: mResult.AGREENO,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Type",
          Value: mResult.STUDYTYPE,
          Path: "",
        });
        mDataSet.push({
          Name: "Consultant",
          Value: mResult.CONSULTANT,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION_S + "/" + mResult.PE,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Status",
          Value: mResult.STUDYSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Design Approach",
          Value: mResult.APPROACH,
          Path: "",
        });
        mDataSet.push({
          Name: "Option Assessment Accepted",
          Value: mResult.OPTIONASSESSMENT,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Report No.",
          Value: mResult.S23_REPORTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "Programme / Actual Commencement",
          Value: mResult.COMMENCEMENTDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Programme / Actual Completion",
          Value: mResult.COMPLETIONDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Report Recommendation (for stage 2 study)",
          Value: mResult.RECOMMEND,
          Path: "",
        });
        mDataSet.push({
          Name: "District Check Status",
          Value: mResult.DISTRICTCHECK,
          Path: "",
        });
        mDataSet.push({
          Name: "Checking Certificate No.",
          Value: mResult.CHECKCERTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Engineer's Remarks",
          Value: mResult.REMARKS,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });

        mDataSet.push({
          Name: <span style={attrTitleStyle}>LPM/LPMit Works</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Works Contract No.",
          Value: mResult.CONTRACTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION_W + "/" + mResult.GE,
          Path: "",
        });
        mDataSet.push({
          Name: "Contractor",
          Value: mResult.CONTRACTOR,
          Path: "",
        });
        mDataSet.push({
          Name: "Progress Status",
          Value: mResult.PROGRESSSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Reason of Study Termination / Works Deletion (if necessary)",
          Value: mResult.REASONDELETE,
          Path: "",
        });
        mDataSet.push({
          Name: "Forecast Commencement Date",
          Value: mResult.COMMENCEMENTDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Forecast Completion Date",
          Value: mResult.COMPLETIONDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Completion Cert. Issued",
          Value: mResult.COMPLETIONCERTDATE,
          Path: "",
        });
        mDataSet.push({
          Name: "Site Handed Over to Maintenance Department on",
          Value: mResult.DATEOFHANDOVER,
          Path: "",
        });
        mDataSet.push({
          Name: "Estimated Cost for Upgrading (HK$M)",
          Value: mResult.TOTALCOST,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Manual No.",
          Value: mResult.MMNO,
          Path: "",
        });
        mDataSet.push({ Name: "Actual Works", Value: mResult.WORKS, Path: "" });
        mDataSet.push({
          Name: "No. of Tree Felled",
          Value: mResult.NOTREEFELL,
          Path: "",
        });
        mDataSet.push({
          Name: "No. of Tree Planted (incl. transplant)",
          Value: mResult.NOTREEPLANT,
          Path: "",
        });
        mDataSet.push({
          Name: "% Bare of Slope Surfacing",
          Value: mResult.SLPBARE,
          Path: "",
        });
        mDataSet.push({
          Name: "% Vegetated of Slope Surfacing",
          Value: mResult.SLPVEGETATE,
          Path: "",
        });
        mDataSet.push({
          Name: "% Shotcrete of Slope Surfacing",
          Value: mResult.SLPSHOTCRETE,
          Path: "",
        });
        mDataSet.push({
          Name: "Other Hard Surface of Slope Surfacing",
          Value: mResult.SLPOTHERHARDSURF,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });
        mDataSet.push({ Name: " ", Value: "", Path: "" });
      }

      if (mResults.length > 0) {
        var mResult = mResults[0];
        for (let i = 0; i < mResult.REPORTs.length; i++) {
          if (i == 0) {
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Study Report</span>,
              Value: "",
              Path: "",
            });
          }
          var mReport = mResult.REPORTs[i];
          var mPath = mReport.URL;
          let mData = {
            Name: mReport.FILENAME,
            Value: (
              <a href={DownloadFromWebAPI(mPath)} target="_blank">
                Open Link
              </a>
            ),
            Path: mPath,
          };
          mDataSet.push(mData);
        }
      }
      return mDataSet;
    },
  },
  {
    name: "Stage 2(H) Study",
    layer: "SlopeInfo",
    layerId: 30,
    itemDetailType: "API",
    srvEndPt: "S2HStudyAreas",
    queryValue: "SA_NO",

    aliasList: [],
    attrTransform: function(mResults) {
      let mDataSet = [];
      for (let j = 0; j < mResults.length; j++) {
        var mResult = mResults[j];
        var mResultReports = mResult.Reports;
        var mResultS3hs = mResult.S3Hs;

        mDataSet.push({ Name: <span style={attrTitleStyle}>Study Area</span> });
        mDataSet.push({
          Name: "Agreement No.",
          Value: mResult.AGREENO,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Study Area No.",
          Value: mResult.STUDYNO,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Location",
          Value: mResult.LOCATION,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Commencement Date",
          Value: mResult.COMMENCEMENTDATE,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Completion Date",
          Value: mResult.COMPLETIONDATE,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Study Status",
          Value: mResult.STUDYSTATUS,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Block Vote Item",
          Value: mResult.BVITEM,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "1st Submission to Checking Panel",
          Value: mResult.SUBMISSION,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Acceptation Date",
          Value: mResult.ACCEPTATION,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Check Panel Ref.",
          Value: mResult.CHECKPANELREF,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "GE",
          Value: mResult.GE,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Study Report No.",
          Value: mResult.S2H_REPORTNO,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
        mDataSet.push({
          Name: "Remarks",
          Value: mResult.REMARK,
          Path: "",
          AgreeNo: mResult.AGREENO,
        });

        var mData;
        for (var i = 0; i < mResult.REPORTs.length; i++) {
          if (i == 0) {
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Study Report</span>,
            });
          }

          var mReport = mResult.REPORTs[i];
          var mPath = DownloadFromWebAPI(mReport.URL);
          mData = {
            Name: mReport.FILENAME,
            Value: (
              <a href={mPath} target="_blank">
                Open Link
              </a>
            ),
            Path: mPath,
            AgreeNo: mResult.AGREENO,
          };
          mDataSet.push(mData);
        }
        for (i = 0; i < mResult.CATCHMENTs.length; i++) {
          if (i == 0) {
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Stage 3(H) Study</span>,
            });
          }

          var mCatchment = mResult.CATCHMENTs[i];
          mData = {
            Name: "Catchment No.",
            Value: mCatchment.CATCHMENTNO,
            Path: "",
            AgreeNo: mResult.AGREENO,
          };
          mDataSet.push(mData);
        }
        mDataSet.push({
          Name: <span />,
          Value: "",
          Path: "",
          AgreeNo: mResult.AGREENO,
        });
      }
      return mDataSet;
    },
  },
  {
    name: "Stage 3 Study",
    layer: "SlopeInfo",
    layerId: 29,
    itemDetailType: "API",
    srvEndPt: "S23StudyWorks",
    queryValue: "SLOPE_NO",
    allowSavePdf: "LPM Stage 2 / 3 Study",
    aliasList: [],
    attrTransform: function(mResults) {
      let mDataSet = [];
      for (let i = 0; i < mResults.length; i++) {
        var mResult = mResults[i];
        mDataSet.push({
          Name: (
            <span style={attrTitleStyle}>
              LPM/LPMit Details ({mResult.AGREENO})
            </span>
          ),
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "LPM Study Feature No.",
          Value: mResult.FEATURENO,
          Path: "",
        });
        mDataSet.push({ Name: "Location", Value: mResult.LOCATION, Path: "" });
        mDataSet.push({
          Name: "District Council",
          Value: mResult.DISTRICTCOUNCIL,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Responsibility (at the time of selection)",
          Value: mResult.MR,
          Path: "",
        });
        mDataSet.push({
          Name: "Responsible Party for maintenance of Government portion",
          Value: mResult.GOV_PTY,
          Path: "",
        });
        mDataSet.push({
          Name: "Private Lot No.",
          Value: mResult.PRI_PTY,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });

        mDataSet.push({
          Name: <span style={attrTitleStyle}>LPM/LPMit Study</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Agreement No.",
          Value: mResult.AGREENO,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Type",
          Value: mResult.STUDYTYPE,
          Path: "",
        });
        mDataSet.push({
          Name: "Consultant",
          Value: mResult.CONSULTANT,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION_S + "/" + mResult.PE,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Status",
          Value: mResult.STUDYSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Design Approach",
          Value: mResult.APPROACH,
          Path: "",
        });
        mDataSet.push({
          Name: "Option Assessment Accepted",
          Value: mResult.OPTIONASSESSMENT,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Report No.",
          Value: mResult.S23_REPORTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "Programme / Actual Commencement",
          Value: mResult.COMMENCEMENTDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Programme / Actual Completion",
          Value: mResult.COMPLETIONDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Report Recommendation (for stage 2 study)",
          Value: mResult.RECOMMEND,
          Path: "",
        });
        mDataSet.push({
          Name: "District Check Status",
          Value: mResult.DISTRICTCHECK,
          Path: "",
        });
        mDataSet.push({
          Name: "Checking Certificate No.",
          Value: mResult.CHECKCERTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Engineer's Remarks",
          Value: mResult.REMARKS,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });

        mDataSet.push({
          Name: <span style={attrTitleStyle}>LPM/LPMit Works</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Works Contract No.",
          Value: mResult.CONTRACTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION_W + "/" + mResult.GE,
          Path: "",
        });
        mDataSet.push({
          Name: "Contractor",
          Value: mResult.CONTRACTOR,
          Path: "",
        });
        mDataSet.push({
          Name: "Progress Status",
          Value: mResult.PROGRESSSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Reason of Study Termination / Works Deletion (if necessary)",
          Value: mResult.REASONDELETE,
          Path: "",
        });
        mDataSet.push({
          Name: "Forecast Commencement Date",
          Value: mResult.COMMENCEMENTDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Forecast Completion Date",
          Value: mResult.COMPLETIONDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Completion Cert. Issued",
          Value: mResult.COMPLETIONCERTDATE,
          Path: "",
        });
        mDataSet.push({
          Name: "Site Handed Over to Maintenance Department on",
          Value: mResult.DATEOFHANDOVER,
          Path: "",
        });
        mDataSet.push({
          Name: "Estimated Cost for Upgrading (HK$M)",
          Value: mResult.TOTALCOST,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Manual No.",
          Value: mResult.MMNO,
          Path: "",
        });
        mDataSet.push({ Name: "Actual Works", Value: mResult.WORKS, Path: "" });
        mDataSet.push({
          Name: "No. of Tree Felled",
          Value: mResult.NOTREEFELL,
          Path: "",
        });
        mDataSet.push({
          Name: "No. of Tree Planted (incl. transplant)",
          Value: mResult.NOTREEPLANT,
          Path: "",
        });
        mDataSet.push({
          Name: "% Bare of Slope Surfacing",
          Value: mResult.SLPBARE,
          Path: "",
        });
        mDataSet.push({
          Name: "% Vegetated of Slope Surfacing",
          Value: mResult.SLPVEGETATE,
          Path: "",
        });
        mDataSet.push({
          Name: "% Shotcrete of Slope Surfacing",
          Value: mResult.SLPSHOTCRETE,
          Path: "",
        });
        mDataSet.push({
          Name: "Other Hard Surface of Slope Surfacing",
          Value: mResult.SLPOTHERHARDSURF,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });
        mDataSet.push({ Name: " ", Value: "", Path: "" });
      }

      if (mResults.length > 0) {
        var mResult = mResults[0];
        for (let i = 0; i < mResult.REPORTs.length; i++) {
          if (i == 0) {
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Study Report</span>,
              Value: "",
              Path: "",
            });
          }
          var mReport = mResult.REPORTs[i];
          var mPath = mReport.URL;
          let mData = {
            Name: mReport.FILENAME,
            Value: (
              <a href={DownloadFromWebAPI(mPath)} target="_blank">
                Open Link
              </a>
            ),
            Path: mPath,
          };
          mDataSet.push(mData);
        }
      }
      return mDataSet;
    },
  },
  {
    name: "Stage 3(H) Study",
    layer: "SlopeInfo",
    layerId: 31,
    itemDetailType: "API",
    srvEndPt: "S3HStudyWorks",
    queryValue: (row) => ({
      AgreeNo: "",
      StudyNo: "",
      CatchmentNo: row.FEATURENO,
    }),

    aliasList: [],
    attrTransform: function(mResults) {
      let mDataSet = [];

      for (let j = 0; j < mResults.length; j++) {
        var mResult = mResults[j];

        mDataSet.push({
          Name: <span style={attrTitleStyle}>Catchment Study</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Agreement No.",
          Value: mResult.AGREENO,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Area No.",
          Value: mResult.STUDYNO,
          Path: "",
        });
        mDataSet.push({
          Name: "Catchment No.",
          Value: mResult.CATCHMENTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Type",
          Value: mResult.STUDYTYPE,
          Path: "",
        });
        mDataSet.push({
          Name: "Consultant",
          Value: mResult.CONSULTANT,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION + "/" + mResult.GE,
          Path: "",
        });
        mDataSet.push({
          Name: "Commencement Date",
          Value: mResult.COMMENCEMENTDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Completion Date",
          Value: mResult.COMPLETIONDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Status",
          Value: mResult.STUDYSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "1st Submission Date to District",
          Value: mResult.SUBMIT_TO_DISTRICT,
          Path: "",
        });
        mDataSet.push({
          Name: "Acceptance Date by district",
          Value: mResult.ACCEPTED_BY_DISTRICT,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Report No.",
          Value: mResult.S3H_REPORTNO,
          Path: "",
        });
        mDataSet.push({ Name: "Remarks", Value: mResult.REMARKS_S, Path: "" });
        mDataSet.push({
          Name: <span style={attrTitleStyle}>Catchment Works</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Works Contract No.",
          Value: mResult.CONTRACTNO,
          Path: "",
        });
        mDataSet.push({ Name: "BV Item", Value: mResult.BV_ITEM, Path: "" });
        mDataSet.push({
          Name: "Commencement Date",
          Value: mResult.COMMENCEMENTDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Completion Date",
          Value: mResult.COMPLETIONDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Work Status",
          Value: mResult.PROGRESSSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Work Cost",
          Value: mResult.WORKSCOST,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Manual No.",
          Value: mResult.MMNO,
          Path: "",
        });
        mDataSet.push({ Name: "Remarks", Value: mResult.REMARKS_W, Path: "" });

        for (let i = 0; i < mResult.REPORTs.length; i++) {
          if (i == 0) {
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Study Report</span>,
              Value: "",
              Path: "",
            });
          }

          var mReport = mResult.REPORTs[i];
          var mPath = mReport.URL;
          let mData = {
            Name: mReport.FILENAME,
            Value: (
              <a href={DownloadFromWebAPI(mPath)} target="_blank">
                Open Link
              </a>
            ),
            Path: mPath,
          };
          mDataSet.push(mData);
        }

        mDataSet.push({ Name: <span />, Value: "", Path: "" });
      }

      return mDataSet;
    },
  },
  {
    name: "Strategic Cavern Areas",
    layer: "SlopeInfo",
    layerId: 16,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "SCVA No.", Value: "SCVA_No" },
      { Name: "Location", Value: "SCVA_Name" },
      {
        Name: "Information Note of the SCVA",
        Value: "SCVA_No",
        format: (v, r) => (
          <a
            href={DownloadFromWebAPI([
              "esfsshare1",
              `Cavern_Master_Plan/Strategic Cavern Areas/${v}.pdf`,
            ])}
            target="_blank"
          >
            Open URL
          </a>
        ),
      },
      {
        Name: "Cavern Master Plan",
        Value: "SCVA_No",
        format: (v, r) => (
          <a
            href={DownloadFromWebAPI([
              "esfsshare1",
              "Cavern_Master_Plan/Cavern Master Plan.pdf",
            ])}
            target="_blank"
          >
            Open URL
          </a>
        ),
      },
      {
        Name: "Explanatory Statement",
        Value: "SCVA_No",
        format: (v, r) => (
          <a
            href={DownloadFromWebAPI([
              "esfsshare1",
              "Cavern_Master_Plan/Explanatory Statement.pdf",
            ])}
            target="_blank"
          >
            Open URL
          </a>
        ),
      },
    ],
  },
  {
    name: "Tension Crack (known)",
    layer: "SlopeInfo",
    layerId: 22,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [],
    attrTransform: function(attributes) {
      let pGraphic = { attributes };
      var mTERRAIN = pGraphic.attributes["TERRAIN"];
      mTERRAIN = mTERRAIN.replace(
        "L",
        "within or in the immediate vicinity of known recent or relict landslide scar(s)"
      );
      mTERRAIN = mTERRAIN.replace(
        "NT",
        "neither within nor in the immediate vicinity of known recent or relict landslide scar(s)"
      );
      mTERRAIN = mTERRAIN.trim();
      if (mTERRAIN == "") mTERRAIN = "No information";

      var mSOIL = pGraphic.attributes["SOIL"];
      mSOIL = mSOIL
        .replace("CDA", "completely decomposed andesite")
        .replace("CDG", "completely decomposed granite")
        .replace("CDT", "completely decomposed tuff");
      mSOIL = mSOIL
        .replace("CDZ", "completely decomposed siltstone")
        .replace("COLL", "colluvium")
        .replace("FILL", "anthropogenic fill");
      mSOIL = mSOIL
        .replace("HDG", "highly decomposed granite")
        .replace("HDT", "highly decomposed tuff")
        .replace("RS", "residual soil");
      mSOIL = mSOIL.replace("RTS", "recent top soil");
      mSOIL = mSOIL.trim();
      if (mSOIL == "") mSOIL = "No information";

      var mL_INFO = pGraphic.attributes["L_INFO"];
      if (mL_INFO == "0") mL_INFO = "No information";

      var mWIDTH = pGraphic.attributes["WIDTH"];
      if (mWIDTH == "0") mWIDTH = "No information";

      var mDEPTH = pGraphic.attributes["DEPTH"];
      if (mDEPTH == "0") mDEPTH = "No information";

      var mV_OFFSET = pGraphic.attributes["V_OFFSET"];
      if (mV_OFFSET == "0") mV_OFFSET = "No information";

      var mSOURCE_REF = pGraphic.attributes["SOURCE_REF"];
      mSOURCE_REF = mSOURCE_REF.replace(
        "ADR",
        "Advisory Report (GEO Internal Report)"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "API-HLC",
        "Aerial Photograph Interpretation for Compilation of the Historical Landslide Catchments Inventory"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "API-HPA",
        "Aerial Photograph Interpretation for High Priority Area Catchments"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "GASP",
        "Geotechnical Area Study Programme Report"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "Hillfire",
        "Report on Helicopter Reconnaissance on Hillsides affected by Major Hillfires"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "KS-2008",
        "Summary Report on the Identification of June 2008 Natural Terrain Landslides on Lantau Island"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "LM-2001",
        "Landslide Mapping Report under Agreement No. 47/2000 – Natural Terrain Hazard Study for Tsing Shan Foothill Area"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "LM-2008",
        "Landslide Mapping Report for 2008 Natural Terrain Landslides"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "LM4",
        "Final Report of Agreement No. CE 4/2005 (GE) – Landslide Assessment and Monitoring at Four Selected Sites"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "LSR",
        "Landslide Study Report (GEO Internal Report)"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "NTHS",
        "non-LPMitP Natural Terrain Hazard Study under Government or Private Development Projects"
      );
      mSOURCE_REF = mSOURCE_REF.replace(
        "S2(H)R",
        "Stage 2(H) Study Report under LPMitP"
      );

      var mVERIF_BY = pGraphic.attributes["VERIF_BY"];
      mVERIF_BY = mVERIF_BY.replace("FM", "field mapping");
      mVERIF_BY = mVERIF_BY.replace("HR", "helicopter reconnaissance");
      mVERIF_BY = mVERIF_BY.replace("TP", "trial pit");
      mVERIF_BY = mVERIF_BY.replace("TT", "trial trench");

      var mCOMMENT = pGraphic.attributes["COMMENT"];
      mCOMMENT = mCOMMENT.trim();
      if (mCOMMENT == "") mCOMMENT = "-";

      return [
        {
          Name: "Tension Crack ID",
          Value: pGraphic.attributes["KTC_ID"],
          Path: "",
        },
        { Name: "Location", Value: pGraphic.attributes["LOCATION"], Path: "" },
        { Name: "Type of Terrain", Value: mTERRAIN, Path: "" },
        { Name: "Type of Soil", Value: mSOIL, Path: "" },
        {
          Name: "Calculated Length (m)",
          Value: pGraphic.attributes["L_CAL"],
          Path: "",
        },
        { Name: "Recorded Lenght (m)", Value: mL_INFO, Path: "" },
        { Name: "Recorded Width (m)", Value: mWIDTH, Path: "" },
        { Name: "Recorded Depth (m)", Value: mDEPTH, Path: "" },
        { Name: "Recorded Vertical Offset (m)", Value: mV_OFFSET, Path: "" },
        {
          Name: "Year",
          Value: pGraphic.attributes["YEAR"] + " (Identified)",
          Path: "",
        },
        { Name: "Source", Value: mSOURCE_REF, Path: "" },
        {
          Name: "Source No.",
          Value: pGraphic.attributes["SOURCE_NO"],
          Path: "",
        },
        { Name: "Verification", Value: mVERIF_BY, Path: "" },
        { Name: "Comment", Value: mCOMMENT, Path: "" },
        {
          Name: "File",
          Value: (
            <a
              href={DownloadFromWebAPI([
                "esfsshare1",
                `Tension_Crack/${pGraphic.attributes["FILE_NAME"]}`,
              ])}
              target="_blank"
            >
              {pGraphic.attributes["FILE_NAME"]}
            </a>
          ),
        },
      ];
    },
  },
  {
    name: "Tunnel Submission Records",
    layer: "SlopeInfo",
    layerId: 64,
    itemDetailType: "attrTbl",
    srvEndPt: "",
    queryValue: "",

    aliasList: [
      { Name: "Project ID", Value: "PROJECT_ID" },
      { Name: "Project Title", Value: "PROJECT_TITLE" },
      { Name: "Client Office", Value: "CLIENT_OFFICE" },
      { Name: "Consultant", Value: "CONSULTANT" },
      { Name: "Agreement Title", Value: "AGREEMENT_TITLE" },
      { Name: "Agreement No.", Value: "AGREEMENT_NO" },
      { Name: "GEO District", Value: "GEO_DISTRICT" },
      { Name: "GEO Engineer", Value: "GEO_ENGINEER" },
      { Name: "Document Title", Value: "DOCUMENT_TITLE" },
      { Name: "Document No.", Value: "DOCUMENT_NO" },
      { Name: "Document Type", Value: "DOCUMENT_TYPE" },
      { Name: "Document Date", Value: "DOCUMENT_DATE", type: "date" },
      {
        Name: "Hotlink",
        Value: "DOCUMENT_PATH",
        format: (v, r) => (
          <a
            href={DownloadFromWebAPI(["esfsshare1", `tunnel_report/${v}`])}
            target="blank"
          >
            Hotlink
          </a>
        ),
      },
    ],
  },
  {
    name: "Unauthorized Slope Works",
    layer: "SlopeInfo",
    layerId: 16,
    itemDetailType: "API",
    srvEndPt: "USW",
    queryValue: "Tagmark",

    aliasList: [
      { Name: "Tagmark", Value: "Tagmark" },
      { Name: "File Ref.", Value: "FILEREF" },
      { Name: "Folio", Value: "FOLIO" },
      { Name: "ERKS File Ref.", Value: "ERKSREF" },
      { Name: "ERKS Part & Folio", Value: "ERKSFOLIO" },
    ],
  },
  {
    name: "Works Upgrading Boundary",
    layer: "SlopeInfo",
    layerId: 32,
    itemDetailType: "API",
    srvEndPt: "S23StudyWorks",
    queryValue: "SLOPE_NO",
    allowSavePdf: "LPM Works Upgrading Boundary",
    aliasList: [],
    attrTransform: function(mResults) {
      let mDataSet = [];
      for (let i = 0; i < mResults.length; i++) {
        var mResult = mResults[i];
        mDataSet.push({
          Name: (
            <span style={attrTitleStyle}>
              LPM/LPMit Details {mResult.AGREENO}
            </span>
          ),
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "LPM Study Feature No.",
          Value: mResult.FEATURENO,
          Path: "",
        });
        mDataSet.push({ Name: "Location", Value: mResult.LOCATION, Path: "" });
        mDataSet.push({
          Name: "District Council",
          Value: mResult.DISTRICTCOUNCIL,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Responsibility (at the time of selection)",
          Value: mResult.MR,
          Path: "",
        });
        mDataSet.push({
          Name: "Responsible Party for maintenance of Government portion",
          Value: mResult.GOV_PTY,
          Path: "",
        });
        mDataSet.push({
          Name: "Private Lot No.",
          Value: mResult.PRI_PTY,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });

        mDataSet.push({
          Name: <span style={attrTitleStyle}>LPM/LPMit Study</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Agreement No.",
          Value: mResult.AGREENO,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Type",
          Value: mResult.STUDYTYPE,
          Path: "",
        });
        mDataSet.push({
          Name: "Consultant",
          Value: mResult.CONSULTANT,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION_S + "/" + mResult.PE,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Status",
          Value: mResult.STUDYSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Design Approach",
          Value: mResult.APPROACH,
          Path: "",
        });
        mDataSet.push({
          Name: "Option Assessment Accepted",
          Value: mResult.OPTIONASSESSMENT,
          Path: "",
        });
        mDataSet.push({
          Name: "Study Report No.",
          Value: mResult.S23_REPORTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "Programme / Actual Commencement",
          Value: mResult.COMMENCEMENTDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Programme / Actual Completion",
          Value: mResult.COMPLETIONDATE_S,
          Path: "",
        });
        mDataSet.push({
          Name: "Report Recommendation (for stage 2 study)",
          Value: mResult.RECOMMEND,
          Path: "",
        });
        mDataSet.push({
          Name: "District Check Status",
          Value: mResult.DISTRICTCHECK,
          Path: "",
        });
        mDataSet.push({
          Name: "Checking Certificate No.",
          Value: mResult.CHECKCERTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Engineer's Remarks",
          Value: mResult.REMARKS,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });

        mDataSet.push({
          Name: <span style={attrTitleStyle}>LPM/LPMit Works</span>,
          Value: "",
          Path: "",
        });
        mDataSet.push({
          Name: "Works Contract No.",
          Value: mResult.CONTRACTNO,
          Path: "",
        });
        mDataSet.push({
          Name: "GEO Managing Section / Engineer",
          Value: mResult.DIVISION_W + "/" + mResult.GE,
          Path: "",
        });
        mDataSet.push({
          Name: "Contractor",
          Value: mResult.CONTRACTOR,
          Path: "",
        });
        mDataSet.push({
          Name: "Progress Status",
          Value: mResult.PROGRESSSTATUS,
          Path: "",
        });
        mDataSet.push({
          Name: "Reason of Study Termination / Works Deletion (if necessary)",
          Value: mResult.REASONDELETE,
          Path: "",
        });
        mDataSet.push({
          Name: "Forecast Commencement Date",
          Value: mResult.COMMENCEMENTDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Forecast Completion Date",
          Value: mResult.COMPLETIONDATE_W,
          Path: "",
        });
        mDataSet.push({
          Name: "Completion Cert. Issued",
          Value: mResult.COMPLETIONCERTDATE,
          Path: "",
        });
        mDataSet.push({
          Name: "Site Handed Over to Maintenance Department on",
          Value: mResult.DATEOFHANDOVER,
          Path: "",
        });
        mDataSet.push({
          Name: "Estimated Cost for Upgrading (HK$M)",
          Value: mResult.TOTALCOST,
          Path: "",
        });
        mDataSet.push({
          Name: "Maintenance Manual No.",
          Value: mResult.MMNO,
          Path: "",
        });
        mDataSet.push({ Name: "Actual Works", Value: mResult.WORKS, Path: "" });
        mDataSet.push({
          Name: "No. of Tree Felled",
          Value: mResult.NOTREEFELL,
          Path: "",
        });
        mDataSet.push({
          Name: "No. of Tree Planted (incl. transplant)",
          Value: mResult.NOTREEPLANT,
          Path: "",
        });
        mDataSet.push({
          Name: "% Bare of Slope Surfacing",
          Value: mResult.SLPBARE,
          Path: "",
        });
        mDataSet.push({
          Name: "% Vegetated of Slope Surfacing",
          Value: mResult.SLPVEGETATE,
          Path: "",
        });
        mDataSet.push({
          Name: "% Shotcrete of Slope Surfacing",
          Value: mResult.SLPSHOTCRETE,
          Path: "",
        });
        mDataSet.push({
          Name: "Other Hard Surface of Slope Surfacing",
          Value: mResult.SLPOTHERHARDSURF,
          Path: "",
        });
        mDataSet.push({ Name: " ", Value: "", Path: "" });
        mDataSet.push({ Name: " ", Value: "", Path: "" });
      }

      if (mResults.length > 0) {
        var mResult = mResults[0];
        for (let i = 0; i < mResult.REPORTs.length; i++) {
          if (i == 0) {
            mDataSet.push({
              Name: <span style={attrTitleStyle}>Study Report</span>,
              Value: "",
              Path: "",
            });
          }
          var mReport = mResult.REPORTs[i];
          var mPath = DownloadFromWebAPI(mReport.URL);
          let mData = {
            Name: mReport.FILENAME,
            Value: (
              <a href={mPath} target="_blank">
                Open Link
              </a>
            ),
          };
          mDataSet.push(mData);
        }
      }
      return mDataSet;
    },
  },
  {
    name: "Squatter Warning Sign",
    itemDetailType: "attrTbl",
    aliasList: [{ Name: "WS_NO", Value: "WS_NO" }],
  },
  {
    name: "Active Construction Sites (ACS)",
    itemDetailType: "messagebox",
    msgBoxText: "No further information for this search result",
  },
  {
    name: "API Report",
    itemDetailType: "messagebox",
    msgBoxText: "No further information for this search result",
  },
  {
    name: "Studied Area",
    itemDetailType: "messagebox",
    msgBoxText: "No further information for this search result",
  },
  {
    name: "MTR Protection Zone",
    itemDetailType: "messagebox",
    msgBoxText: (
      <span>
        The MTR protection zone is converted from spatial layer given in the LIC
        Base Map. The MTR maintains the most up-to-date railway protection zone
        and can be accessed in their{" "}
        <a
          href="http://www.mtr.com.hk/en/corporate/operations/protection_boundary_map.html"
          target="_blank"
        >
          <u>website</u>
        </a>
      </span>
    ),
  },
  {
    name: "Borehole Location",
    itemDetailType: "gireport",
  },
];
